import appConfig from "../../../config/app_config";
import { store } from "../../store.js"; // Uses the library to store or retrieve generic data

export const EN = {
  FORM_VALIDATE_1_TITLE:
    "Have you correctly filled all the required parameters?",
  FORM_VALIDATE_1_BODY_1:
    'For polyline, click "Define area" and then alt + click the polygon',
  FORM_VALIDATE_1_BODY_2:
    "For latitude and longitude, mouse right click on the center point",
  FORM_VALIDATE_1_BODY_3: "Transport type is missing",
  FORM_VALIDATE_1_BODY_4:
    "Polyline has reached the max length of 4096 characters",
  FORM_VALIDATE_1_BODY_5: "Select a PartOf location",
  HELPER_DRAW_POLYLINE: "Draw your location polyline",
  HELPER_DRAW_POLYLINE_2:
    "Alt+Click to set locations polyline points\n\nThen Right-click to set the center point",
  CONTEXT_PLAN: "Plan",
  CONTEXT_TAGS: "Tags",
  CONTEXT_ADD: "Add Child",
  CONTEXT_EDIT: "Edit",
  CONTEXT_REMOVE: "Delete Child",
  EMAIL: "Email",
  NO_REPLY_EMAIL: "No reply email address",
  LOG_OUT: "Log out",
  DOUBLEUSERGROUP_ERROR: "Sorry, you can only set 1 partner group to a user.",
  DUPLICATEDPARTNERNAME_ERROR:
    "Sorry, the partner name already exists within our system, please change the name and continue.",

  // Capacity Info page
  CAPACITY_INFO: "Capacity info",
  CAP_CAL_FOR: "Capacity calendar for",
  CAP_SEL_EVENT: "Please select an event to retrieve the calendar data",
  CAP_EVENT_CAP: "Event capacity: ",
  CAP_FREE_EVENT_CAP: "Free event capacity: ",
  CAP_FREE_BATCH_CAP: "Free batch capacity: ",
  CAP_BOOKED_BATCH_CAP: "Booked batch capacity: ",
  CAP_CUR_OCCUPANCY: "Current occupancy: ",
  CAP_TOTAL_EVENT_CAP: "Total event capacity: ",
  CAP_BATCH_TIME: "Batch time: ",
  CAP_TOTAL_BATCH_CAP: "Total batch capacity: ",

  CREATE_EVENT: "New Event",
  CATEGORIES_NONE: "No categories available",

  EVENT_GRAPH_ORDER_TYPE:
    "The selected event might have a Delivery and a Take away option, please select one (if possible) to visualize the graph:",
  EVENT_GRAPH_SELECT_ORDER_TYPE: "Please select the order type",
  EVENT_GRAPH_DATE_PICKER:
    "Select a date to view the expected crowds based on the number of reservations that day",
  EVENT_GRAPH_DETAILS: "Expected crowds",

  //payments status error
  EXPIRED: "Expired",
  CANCELED: "Cancelled",
  FAILED: "Failed",

  COMM_MGR_05: "No users were found matching the selected criteria!",
  DEFINE_AREA: "Define area",

  PIN: "Pin",
  WELCOME_MESSAGE_TITLE: "Welcome",
  WELCOME_MESSAGE:
    "Welcome to your personal page. Here you’ll find everything you need to plan and personalize your visit to " +
    appConfig.dss.environmentName +
    ". You can easily change your preferences at Settings. We wish you a lot of fun during your visit to  " +
    appConfig.dss.environmentName +
    " ",

  EDIT: "Edit",
  EDIT_MESSAGE: "Edit message",

  MESSAGE_TITLE_1: "What kind of a message do you want to send?",
  MESSAGE_TITLE_2:
    "You can choose for a single message or start an engagement campaign",
  MESSAGE_TITLE_3:
    "To send a message I need to know who you want to send it to.",
  MESSAGE_TITLE_4:
    "What do you want to be send and when it should be delivered to them?",
  MESSAGE_TITLE_5:
    "Which group of visitors do you want tot reach with your engagement campaign?",
  MESSAGE_CATEGORY: "Message category",
  SELECT_MESSAGE_CATEGORY: "Select a Message category",

  PREVIEW: "Preview",

  START: "Inflow batch details ",
  END: " Outflow batch details",
  "DATE/TIMEINFO": "General batch details with all the other fields",
  PRICECATEGORIES: "Batch pricing details",
  PRICECATEGORY_MIN_QUANTITY: "Minimum quantity",
  PRICECATEGORY_MAX_QUANTITY: "Maximum quantity",
  PERIOD_INFO: "Event batch duration details",

  SELECT: "Select",
  CONTRIBUTORS: "contributers",
  PRODUCTS: "Products",
  CHOOSE_YOUR_PRODUCTS: "Choose your products",
  SETTINGS_SAVE_OK: "Settings saved correctly",
  SETTINGS_SAVE_KO: "Error in saving settings",
  MY_VISIT: "My visit",
  EVENTS: "Events",
  SETTINGS: "Settings",
  INTERESTED_IN: "I am interested in events for",
  SELECT_LOCATION: "Select a location",
  SELECT_EVENT: "Select an event",
  SELECT_TIME_PERIOD: "Select a time period",
  SELECT_FROM: "From",
  SELECT_UNTIL: "Until",
  SELECT_WINNER: "Select winner",
  BACK: "Back",
  COMMUNICATION_CENTER: "Communication center",
  SAVED_COMMUNICATION: "Saved Communication",
  NEW_COMMUNICATION: "New communicaton",
  COMMUNICATION: "Communication",
  COMMUNICATIONS: "Communications",
  TYPE: "Type",
  DATE: "Date",
  TIME: "Time",
  CHOOSE_EVENT_OPTION: "Choose an event option",
  CHOOSE_BATCHGROUP_OPTION: "Choose an batchgroup option",
  ENGAGEMENT_CAMPAIGN: "Start an Engagement Campaign",
  ENGAGEMENT_CAMPAIGN_SUB: "Used for the promotion of the event and catering.",
  CATERING_PROMOTION: "Catering promotion",
  SECOND_PROMOTION: "Second promotion",
  PLANBOARD: "Planboard",
  MY_PLANBOARD: "My planboard",
  SHOW_PLANBOARD: "Show planboard",

  HISTORY: "history",
  MY_HISTORY: "My activity history",

  WHOM: "Whom",
  SEND_MESSAGE_TO: "Send message to",
  WHAT: "What",
  TITLE_MESSAGE: "Title message",
  LINK_TEXT: "Outbound link",
  TEXT_MESSAGE: "Text message",
  PROMOCODE: "Promotioncode",
  ADD_FAVORITE: "Add to favourites",
  FAVORITE: "Favorite",
  WHEN: "When",
  NEW_MESSAGE: "New message",
  SINGLE_MESSAGE: "Send a single message",
  SINGLE_MESSAGE_SUB: "Used for updates or extra information to your visitors.",
  THE_LOTTERY: "The Lottery",
  START_LOTTERY: "Start the Lottery",
  FIRST_PROMOTION: "First promotion",
  MESSAGE: "Message",
  MESSAGES: "Messages",
  ERROR_HEADER: "Looks like something went wrong.",
  ERROR_NO_CONNECTION:
    "A problem occurred, please contact the customer support center from The Driving Force",
  USER_PASSPORT: "Passport",
  USER_PICTURE_UPLOAD: "Add Your Photo to make your account personal",
  USER_QR_CODE:
    "This is your personal QR code, you can scan this code to recieve stamps which with a full set of stamps allows you to recieve discount. ",
  DISCOUNT: "Discount",
  ITEM_NUMBER: "Item number",

  EVENT_FLEX_ARRIVAL: "Percentage flexible users",
  EVENT_AVERAGE_WAITTIME: "Average waittime",
  EVENT_MAX_WAITTIME: "Max Waittime",
  EVENT_AVERAGE_DEVIATION: "Average deviation",
  EVENT_MAX_DEVIATION: "Max deviation",
  DISTRIBUTION_IN_TIME: "DIT",
  DISTRIBUTION_IN_TIME_BIG: "Distribution in time",
  DISTRIBUTION_IN_PLACE: "DIP",
  ERROR_LOGIN: "Error, wrong data",
  ERROR: "Error",
  ERROR_EMAIL_EXIST: "email exist",

  TITLE_CHART_0: "Visitors",
  TITLE_CHART_1: "Waittime",
  TITLE_CHART_2: "Entries",
  TITLE_CHART_3: "Incidents",
  TITLE_CHART_4: "Inflow patern visitors",
  TITLE_CHART_5: "Outflow patern",
  EMPTY_SLOT: "Empty slot",
  MOVE_SLOT_FORWARD: "Move slot",
  EVENT_TITLE: "Event dashboard",
  INCIDENT_TITLE: "Incident",
  INCIDENT_TITLE_2: "",
  TOTAL_ARRIVALS: "Total arrivals",

  // Homepage
  USER_LOGGED_OUT: "Succesfully logged out",
  NO_CONTINUE_USING_WEBSITE: "No I want to use the website",
  VIEW_ACTIVITIES: "View",
  SEARCH_ACTIVITY: "Search an activity",
  ACTIVITIES_DESC:
    "Browse through the themes and find activities to your liking",
  ACTIVITIES_FOR_HIGHLIGHT: "Activities for highlight ",
  ACTIVITIES_FOR_LOCATION: "Activities for location ",
  CLOSE_ACTIVITIES: "Close this window",
  GET_ACCOUNT_APP: "Get the accountName app now!",
  ACCOUNT_APP_TEXT:
    "Get the accountName app and be inspired about all your can see and do. The accountName-app offers you a lot of benefits for your visit to " +
    "accountName. Easily find, book and access your favorite activities in a few finger ticks.",
  ACCOUNT_APP_TEXT2:
    "The accountName app is all you need to get the most out of your visit to accountName.",
  WHATS_ON: "What's on",
  WHATS_ON_DESC: "What’s where ",
  FILTER_RESULTS: "Filter results",
  TODAY: "Today",
  NEXT_7_DAYS: "Next 7 days",
  NEXT_30_DAYS: "Next 30 days",
  NEXT_3_MONTHS: "Next 3 months",
  SELECT_SPEC_DAYS: "Select specific days",
  WHAT_IS_WHERE: "What's where",
  WHAT_IS_WHERE_DESC: "See what's where on ",
  ACTIVITIES: "Activities",
  GET_PERS_SUG:
    "Get personalized suggestions by selecting categories with the switches on the left. ",
  USER_WELCOME: "Welcome back ",
  PASS_MAX_FUN: "Create a passport for maximum fun",
  PERS_PASS: "Your personal passport",
  CREATE_PASS_DESC_1:
    "Create your personal passport and get the most out of your visit to ",
  CREATE_PASS_DESC_2:
    "The passport offers you access to exclusive activities and discounts and enables you to fully customize your visit according to your desires and interests. you are guaranteed to have more fun. ",
  CREATE_PASS_NOW: "Create your personal passport now! ",
  CREATE_PASS: "Create passport",
  PASS_DESC_1: "Continue planning your visit or create a new trip to ",
  PASS_DESC_2:
    "Go to your personal passport to view your saved favourites, personal suggestions and interests.",
  GO_TO_PASS: "Go to Account",

  //QR-code scanner
  QR_CODE: "QR-code scanner",
  ENTER_AMOUNT: "Enter the amount of Euros",
  SCAN_CODE: "Scan customer's QR-code",
  ERROR1: "You have not entered anything!",
  LAST_RESULT: "Last result:",

  //User passport
  USER_PASSPORT: "My account",
  USER_PASSPORT_DESC:
    "Create your personal passport to get personalizes activity suggestion, earn special rewards and view your favourite list.",
  USER_INTERRESTS: "Your interests",
  USER_INTERRESTS_DESC:
    "Let us know what activities you’re interested in, so we can offer matching activities. ",
  YOUR_USER_REWARD_LVL: "Your current reward level",
  USER_REWARD_LVL: "Reward level",
  USER_CURRENT_LEVEL: "Current level",
  USER_REWARD_LVL_DESC:
    "Earn reward points by doing activities. Get enough points to reach the next level and unlock special activities and discounts. ",
  USER_FAVORITES: "Your favorites",
  USER_FAVORITES_DESC: "Activities you added to your favourites list. ",
  USER_REWARD_POINTS: "Points",
  USER_EARNED_POINTS: "Earned points",
  USER_POINTS_TO_NEXT_LEVEL: "Points to next level",
  USER_INTERESTS: "My interests",
  DEL_FAV: "Deleting favorite",
  SURE_DELETE_ACTIVITY: "Are you sure you want to delete the activity ",
  SURE_DELETE_FAV: " from your favorites list ? ",
  USER_DETAILS: "Personal details",
  USER_SELECTIONS: "Your selections",
  USER_LOCATION_NOT_FOUND: "Address not found",
  USER_LOCATION_NOT_FOUND_DESC: "The address could not be found",
  USER_LOCATION_NOT_FOUND_DESC2:
    "Something went wrong while saving your data, please try again later",
  USER_DETAILS_NOT_SAVED: "User details are not saved",
  USER_DETAILS_SAVED: "The user details are saved",
  GETTING_USER_INTERESTS: "Getting user interests",
  FILTER_ACTIVITIES: "Filter activities",

  //Incidents
  INCIDENT_DESCRIPTION_REPORTER: "Description of the reporter",
  INCIDENT_DESCRIPTION: "Add a description",
  INCIDENT_HAPPEND: "What kind of incident is involved",
  INCIDENT_FILL_IN: "Fill incident data in",
  INCIDENT_TYPE: "Type incident",
  INCIDENT_LIFE_THREAT: "Levensbedreigend?",
  INCIDENT_SITUATION: "Life threatening?",
  INCIDENT_LOCATION:
    "True? (right click on the map where the incident happened).",
  INCIDENT_EXACT_LOCATION: "Specify the location",
  INCIDENT_DESCRIPTION: "Explanation incident",
  INCIDENT_ROAD_ID: "Road data",
  INCIDENT_ADRESS: "Address data",
  INCIDENT_YES_NO: "Yes/No",
  INCIDENT_GPS: "GPS coordinates",
  INCIDENT_STREET: "Street name",
  INCIDENT_NUMMER: "Number",
  INCIDENT_PLACE: "City name",
  INCIDENT_DESCRIPTION_PLACEHOLDER:
    "Description of the exact location for the emergency services.",
  INCIDENT_ADDITIONAL_LOCATION: "Addition location",
  INCIDENT_PHOTO: "Add comments and photo.",
  INCIDENT_USER: "Name of the reporter",
  NO_INCIDENT_DATA: "No incident data",
  INCIDENT_DIALOG_CLOSE: "Are you sure you want to close this incident?",
  INCIDENT_DIALOG_EDIT: "Do you want to save the changes?",
  GO_INCIDENT: "View",
  NO_USERS: "No users found",
  INCIDENT_CLOSE: "Close incident",
  INCIDENT_REMOVED: "Incident removed",
  INCIDENT_NOT_REMOVED: "Incident fails to remove",
  INCIDENT_DIALOG_CLOSE: "Are you sure you want to close this incident?",
  INCIDENT_DIALOG_EDIT: "Do you want to save the changes?",
  INCIDENT_SEND: "Send",
  INCIDENT_EDIT: "Save changes",
  INCIDENT_PICTURE: "Incident picture",

  INC_1: "Traffic incident",
  INC_2: "Debris",
  INC_3: "Wounded",
  INC_4: "Too crowded",
  INC_5: "Technical failure",
  INC_6: "Traffic accident",
  INC_7: "Fire",
  INC_8: "Suspicious situation",
  YES: "Yes",
  NO: "No",
  YES_SEND_MSG: "Yes - send message",
  SEND_MSG_TO_TS: "Send message to time-slot: ",
  SEND_MSG_TO_TS_CHECK:
    "Are you sure you want to send a message to all the users from time-slot: ",
  ON_THE: " on the ",
  ENTER_TITLE_MSG: "Enter the title for the message",
  ENTER_TEXT_MSG: "Enter the text of the message",

  //Event
  EVENT_ADD_REWARD_LEVEL: "Add reward level",
  EVENT_ASSIGN_REWARDS: "Assign rewards",
  EVENT_ASSIGN_MORE_LOCATIONS: "Assign more locations",
  EVENT_REWARD_MANAGEMENT: "Rewards management",
  EVENT_ASSIGN_EXTRA_LOCATIONS:
    "To assign extra location to this event, please save the event first!",
  EVENT_ASSIGN_REWARD_EXPLANATION:
    "To assign a reward to this event, please save the event first!",
  EVENT_ASSIGN_MORE_LOCATIONS_EXPLANATION:
    "To assign more locations to this event, please save the event first!",
  EVENT_REWARD_EXPLANATION:
    "To add a reward level to this event, please save the event first!",
  EVENT_DISCOUNT_CARDS_EXPLANATION:
    "To add a discount card, please save the event first!",
  EVENT_DISCOUNT_CARDS: "Discount cards",
  EVENT_SUBACTIVITIES: "SubActivities",
  EVENT_ALTERNATIVES: "Alternatives",
  EVENT_TICKET_TYPES: "Ticket types",
  EVENT_EXTRA: "Extra event",
  EVENT_STOP_NAME: "Event stop name",
  EVENT_END_LOCATION: "End location",
  EVENT_START_LOCATION: "Start location",
  EVENT_LOCATION: "Event Location",
  EVENT_ROUTE: "Event route",
  EVENT_RESET: "Reset",
  EVENT_RANKING: "Event ranking",
  EVENT_PARTNER: "Event partner",
  EVENT_PRODUCT: "Event/Products",
  EVENT_DATE_RANGE: "Date range",
  EVENT_AGE_RESTRICTIO: "Age restrictio",
  EVENT_ACTIVE_COMPLETE_TIME: "Activate complete time",
  EVENT_CHECK_IN_TIME: "Check-in time",
  EVENT_CHECK_OUT_TIME: "Check-out time",
  EVENT_ACTIONS: "Actions",
  EVENT_EARLIEST_CHECKIN_TIME: "Earliest check-in time",
  EVENT_LATEST_CHECKIN_TIME: "Latest check-in time",
  EVENT_DURATION_ARRIVAL_BATCHES: "Duration arrival batches",
  EVENT_MAX_INFLOW: "Max inflow",
  EVENT_EARLIEST_CHECKOUT_TIME: "Earliest check-out time",
  EVENT_LATEST_CHECKOUT_TIME: "Latest check-out time",
  EVENT_DURATION_DEPARTURE_BATCHES: "Duration departure batches",
  EVENT_MAX_OUTFLOW: "Max outflow",
  EVENT_STEPS: "Steps",
  EVENT_MINIMAL_DURATION: "Minimal duration",
  EVENT_MAXIMUM_DURATION: "Maximum duration",
  EVENT_BOOKING_POLICY: "Booking policy",
  EVENT_FLEX_PERCENTAGE: "Flex percentage",
  EVENT_PRICE_CATEGORY: "Price category",
  EVENT_ADD_PRICE_CATEGORY: "Add Price category",
  EVENT_THRESHOLD: "Threshold",
  EVENT_PLEASE_ADD_PRICECATEGORY:
    "Please add at least 1 price category to this batchgroup",
  EVENT_EXTERNAL_PLATFORM: "External platforms",
  EVENT_EXTERNAL_EVENT: "External event",
  EVENT_TOUR: "Tours",
  EVENT_AVERAGE_SPEED: "Average speed (km/h)",
  EVENT_DELIVERY_OR_TAKEAWAY:
    "If possible, make a choice if you want the product to be delivered or to collect it yourself.",
  EVENT_INSERT_STARTTIME: "Insert your new start time",
  EVENT_INSERT_ENDTIME: "Insert your new end time",
  EVENT_CURRENT_START_AND_ENDTIME:
    "Your current start and end time for event: eventName is",
  EVENT_CURRENT_START_AND_ENDDATE:
    "Your current start and end date for event: eventName is",
  EVENT_NO_TICKETS_SELECTED: "No tickets are selected",
  EVENT_PLEASE_SELECT_TICKET: "Select please your tickets",
  EVENT_NO_DATE_CHOSEN: "No date chosen",
  EVENT_CHOOSE_DATE: "Please choose a date",
  EVENT_BOOK: "Book Event",
  EVENT_INPUT_TIME_INCORRECT: "The start time is later than the end time",
  EVENT_TIME_INCORRECT: "Time incorrect",
  EVENT_PREFERRED_ARRIVAL: "Preferred arrival time",
  EVENT_PREFERRED_DEPARTURE: "Preferred departure time",
  EVENT_STARTS_EVERY: "Starts every",
  NO_EVENT: "No events found",
  NO_EVENTS_NOW_FOR_PARTNER: "There aren't events found for this partner",
  NO_EVENTS_NOW_FOR_ACCOUNT: "There aren't events found for this account",
  EVENT: "Event",
  EDIT_EVENT: "Edit event",
  EVENT_EDIT: "Select an event to edit",
  EVENT_REGISTRATION: "Event registration",
  EVENT_DURATION: "Duration of the event",
  EVENT_DESC_SHORT: "Description",
  EVENT_LOC_SHORT: "Location",
  EVENT_CAP_SHORT: "Capacity",
  EVENT_CAT_SHORT: "Categories",
  EVENT_PIC_SHORT: "Picture",
  EVENT_BUDGET_SHORT: "Budget",
  EVENT_PARTOF_SHORT: "Part of -Themes-",
  EVENT_TW_SHORT: "Time-Window",
  EVENT_PIC_NONE: "No picture available",
  EVENT_VISIBILITY: "Visible for",
  EVENT_NAME: "Name of event",
  EVENT_TYPE: "Type of event",
  EVENT_DESCRIPTION: "Description of the event",
  EVENT_STARTTIME: "Start time of the event",
  EVENT_ENDTIME: "End time of the event",
  EVENT_INTERVAL: "Interval",
  EVENT_MAXCAPACITY: "Maximum capacity per interval",
  EVENT_INFLOWCAPACITY: "Capacity per interval",
  EVENT_PRICE: "Event price",
  EVENT_MAX_WAIT_TIME: "Max waiting time in minutes",
  EVENT_HISTORIC_ARRIVAL: "Historical arrivals",
  EVENT_LANGUAGE: "Language specifics",
  EVENT_FILTERTYPE: "Filter events on type: ",
  EVENT_AGENDA_NEW: '"New agenda item',
  EVENT_DATES_SELECTION: "Selection of dates",
  EVENT_DAYS_SELECTION: "Selection of days",
  EVENT_START_DATE: "Start-date",
  EVENT_END_DATE: "End-date",
  EVENT_START_TIME: "Start-time",
  EVENT_END_TIME: "End-time",
  EVENT_MAX_INFLOW: "Max inflow",
  EVENT_RATE_PRICE: "Rate price",
  EVENT_REWARD_POINTS: "Reward points",
  EVENT_NO_BATCHGROUPS: "No agenda items available",
  EVENT_MESSAGE_TITLE: "Message title",
  EVENT_MESSAGE_TEXT: "Message text",
  EVENT_MESSAGE_REW_LVL: "Send message to reward level",
  EVENT_USER_SELECTION: "Selection of users",
  EVENT_DATE: "Date",
  EVENT_TIME: "Time",
  EVENT_COMM_TYPE: "Communication type",
  EVENT_MESSAGE_STATUS: "Message status",
  EVENT_MESSAGE_SEND: "Send",
  EVENT_MESSAGE_NOT_SEND: "Not send",
  EVENT_MESSAGE_PICTURE: "Message picture",
  EVENT_MESSAGE_PRODUCT: "Product",
  EVENT_MESSAGE_PRODUCT_OPT: "Product (optional)",
  EVENT_MESSAGE_SELECT_PRODUCT: "Select a product",
  EVENT_ERROR_MSG_1:
    "It seems like you have not (correctly) filled in all the required fields.",
  EVENT_ERROR_MSG_2: "Please fill in all the required fields to continue.",
  EVENT_DEL_AGENDA_ITEM: "Are you sure you want to delete this agenda item?",
  EVENT_DEL_MESSAGE: "Are you sure you want to delete this message?",
  DELIVERY_PARTNER: "Delivery partner",

  //// Event info buttons on the event wizard
  // Event detail screen
  EVENT_FORAGE_MESSAGE:
    "This product has a 18+ rating. Can you confirm You are of the right age",
  EVENT_NAME_INFO:
    "The 'Name of event' determines the name for this event. The Event Name will be visible for customers in the calendar overview.",
  EVENT_TYPE_INFO: "The 'Type of event' determins the type of this event.",
  EVENT_TW_INFO:
    "The 'Time-Window' of an event is either 'Fixed' or 'Repetitive'. If the event occures more than once a day, the event is 'Repetitive'.",
  EVENT_LOC_INFO:
    "The 'Location' is the location in which the event is held. The Location will be visible for customers in the calendar overview.",
  EVENT_PARTOF_INFO:
    "An event can be 'part of' multiple themes. If the event fits seamlessly by a theme, than this event should be added to that theme.",
  EVENT_CAP_INFO: "The 'capacity' is the maximum capacity of the event.",
  EVENT_BUDGET_INFO:
    "The 'Budget' is the budget for an event how many times it will be suggested for a customer based on the 'rate price' of the event.",
  EVENT_LEAD_INFO:
    "The 'Lead-Time' is the amount of lead time in minutes for the event (default set to 0).",
  EVENT_COOL_INFO:
    "The 'Cooldown-Time' is the amount of cooldown time in minutes for the event (default set to 0).",
  DURATION_INFO:
    "The 'Duration' is the duration in minutes for the event (default set to 60).",
  EVENT_DESC_INFO:
    "The 'Description' of the event is a brief introduction of the event. The Description will be visible for customers in the event details screen.",
  EVENT_PIC_INFO:
    "The 'Picture' of the event will be visible for customers in the calendar overview and when a customer opens an event for information / to book.",
  EVENT_YT_LINK_INFO:
    "The youtube link is provided to let the user open up the link in the youtube application or in web.",
  // Event agenda screen
  EVENT_BG_TYPE_INFO:
    "The availability of an agenda item determines how often the agenda item is available. Either specific for specific days or 1 day, or repeating when the agenda item repeats itself.",
  EVENT_DATES_SEL_INFO:
    "The 'Selection of dates' are the dates on which the Specific agenda item is held. Multiple days as an input are possible.",
  EVENT_DAYS_SEL_INFO:
    "The 'Selection of days' are the days in which the repeating agenda item is held. Multiple days as an input are possible.",
  EVENT_START_DATE_INFO:
    "The 'Start-date' is the starting date in which the agenda item is held",
  EVENT_END_DATE_INFO:
    "The 'End-date' is the final date in which is the agenda item is held",
  EVENT_START_TIME_INFO:
    "The 'Start-time' is the starting time of the agenda item.",
  EVENT_END_TIME_INFO: "The 'End-time' is the end time of the agenda item.",
  EVENT_INTERVAL_INFO:
    "The interval is the duration (in minutes) between the end of a single agenda item and the start of the next single agenda item",
  EVENT_DURATION_INFO:
    "The duration of the agenda item is the length (in minutes) from a single agenda item which is possible to set multiple times a day.",
  EVENT_MAXINFLOW_INFO:
    "The 'Max inflow' is the maximum amount of people that can enter the location at the same time",
  EVENT_PRICE_INFO:
    "The 'Event price' is the price to pay for a visitor for this agenda item.",
  EVENT_RATE_PRICE_INFO:
    "The 'Rate price' is the price you are willing to pay extra whenever the agenda item is suggested to a visitor.",
  EVENT_REWARD_POINTS_INFO:
    "The 'Reward points' is the points a visitor can get when the visitor books this agenda item.",
  // Event communication screen
  EVENT_MSG_TITLE_INFO: "The 'Message title' is the title of the message.",
  EVENT_MSG_TEXT_INFO: "The 'Message text' is the text of the message.",
  EVENT_MSG_RWD_LVL_INFO:
    "Each event has three reward levels, click on one of the reward levels to specify the users to send a message to.",
  EVENT_MSG_USER_SEL_INFO:
    "You can choose to send a message to the subscribed users for the event, the un-subscribed users or both.",
  EVENT_MSG_DATE_INFO: "Choose the date on which you want to send the message.",
  EVENT_MSG_TIME_INFO: "Choose the time on which you want to send the message.",
  EVENT_MSG_COMM_TYPE_INFO:
    "Choose the platform type of communication for the to be send message.",

  NEW_QUADRANT: "Create new quadrant",
  TYPE_QUADRANT: "Type of quadrant",
  TYPE_OBJECT: "Object",
  SELECT_SIGNALS: "Select signals",
  NO_INCIDENT: "No incident",
  CONFIRM: "Confirm",
  SELECTED_EVENT: "Selected event",
  QUADRANT_DESC: "Quadrant description",
  MAP_QUADRANT_DESC:
    "The map quadrant uses the location details to visualise the details and position for the selected location.",
  EVENT_QUADRANT_DESC:
    "The event quadrant uses the time-slots of an event to visualise the details and the capacity information of the selected event.",
  INCIDENT_QUADRANT_DESC:
    "The incident quadrant visualises the incidents of a selected location.",
  PRODUCTCAL_QUADRANT_DESC:
    "The product calendar visualises the bookings from rental-events per product.",
  EVENTCAL_QUADRANT_DESC:
    "The Event calendar visualises the calendar for the selected event.",
  LEGENDA_GREY: "Grey bookings: ",
  LEGENDA_RED: "Red bookings: ",
  LEGENDA_BLUE: "Blue bookings: ",
  LEGENDA_YELLOW_BORDER: "Yellow bordered bookings: ",
  LEGENDA_QUADRANT_GREY:
    "The grey colored bookings are external bookings, they do not contain any information.",
  LEGENDA_QUADRANT_RED:
    "The red colored bookings are blocked dates. These dates are not bookable for users.",
  LEGENDA_QUADRANT_BLUE:
    "The blue colored bookings are booking that were booked through our platform. All the information is available.",
  LEGENDA_QUADRANT_YELLOW_BORDER:
    "If a booking has a yellow border around it, it means that the booking is spreaded over multiple days.",
  LEGENDA_RESTRICTIONS:
    "Wenn sich der Kalender in der Wochenansicht befindet, gibt es eine Einschränkung für die Anzeige mehrerer Buchungen zur gleichen Startzeit",
  BASIC_QUADRANT_DESC: "Please pick a quadrant type to view the description.",

  // For helper info in webshopoverview quadrant
  WEBSHOP_QUADRANT_RED_HEADER: "Red bookings: ",
  WEBSHOP_QUADRANT_RED_DETAILS:
    "The red colored bookings are booking that need to be processed by partners before customers can proceed with bookings.",
  WEBSHOP_QUADRANT_BLUE_HEADER: "Blue bookings: ",
  WEBSHOP_QUADRANT_BLUE_DETAILS:
    "The blue colored bookings are booking that have already requested payment to customers.",
  WEBSHOP_QUADRANT_ORANGE_HEADER: "Orange bookings: ",
  WEBSHOP_QUADRANT_ORANGE_DETAILS:
    "The orange colored bookings are booking that are waiting for payments by customers.",
  WEBSHOP_QUADRANT_GREEN_HEADER: "Green bookings: ",
  WEBSHOP_QUADRANT_GREEN_DETAILS:
    "The green colored bookings are booking that have already been confirmed or done by customers.",
  WEBSHOP_QUADRANT_GREY_HEADER: "Grey bookings: ",
  WEBSHOP_QUADRANT_GREY_DETAILS:
    "The grey colored bookings are bookings that are cancelled by customers.",

  //Batchgroup

  BATCHGROUP_NAME: "Name of the batchgroup",
  BATCHGROUP_EDIT: "Edit batchgroup",
  BATCHGROUP_DELETE: "Delete batchgroup",
  BATCHGROUP_CONF_DELETE: "Are you sure want to delete the batchgroup: ",
  BATCHGROUP_DESCRIPTION: "Description of the batchgroup",
  BATCHGROUP_CHAINBOX: "Batchgroup contains chainable batches",
  BATCHGROUP_STARTTIME: "Start time of the batchgroup",
  BATCHGROUP_ENDTIME: "End time of the batchgroup",
  BATCHGROUP_STARTDATE: "Startdate of the batchgroup",
  BATCHGROUP_ENDDATE: "Enddate of the batchgroupp",
  BATCHGROUP_DATES: "Dates of the batchgroup",
  BATCHGROUP_INTERVAL: "Batches start every ....(min)",
  BATCHGROUP_INTERVAL_END: "Batches end every ....(min)",
  BATCHGROUP_CAPACITYPERBATCH: "Capacity per batch",
  BATCHGROUP_DURATION: "Duration of the batch",
  BATCHGROUP_TYPERE: "Repeating timewindow(s)",
  BATCHGROUP_ADD: "Add batchgroup",
  BATCHGROUP_DETAILS: "Batchgroup details",
  BATCHGROUP_CHOOSETYPE: "Choose a batchgroup type",
  BATCHGROUP_DAYS: "Select the day(s) in which the event occurs",
  BATCHGROUP_NOPASTDATE: "Please select a date that is not in the past",
  BATCHGROUP_TYPESP: "Specific date(s)",

  //External calendar
  EXTERNAL_CALENDAR: "External calendar",
  EXTERNAL_CALENDAR_ADD: "Add external calendar",
  EXTERNAL_CALENDAR_DELETE: "Delete external calendar",
  EXTERNAL_CALENDAR_CONF_DELETE:
    "Are you sure you want to delete the following calendar: ",

  //Products
  PRODUCT_CATEGORIES: "Product categories",
  PRODUCT_CATEGORY_EXPLANATION:
    "To add a product category for this event, please save the event first!",
  PRODUCT_ADD_CATEGORY: "Add product category",
  PRODUCT_IN_STOCK: "In stock",
  PRODUCT_DELETE: "Delete product",
  PRODUCT_ASPECT_DELETE: "Delete aspect",
  PRODUCT_ITEM_DELETE: "Delete item",
  PRODUCT_PRICE_CATEGORY_DELETE: "Delete price category",
  PRODUCT_CONF_DELETE: "Are you sure want to delete this product: ",
  PRODUCT_ASPECT_CONF_DELETE: "Are you sure want to delete this aspect: ",
  PRODUCT_ITEM_CONF_DELETE: "Are you sure you want to delete the chosen item? ",
  PRODUCT_PRICE_CATEGORY_CONF_DELETE:
    "Are you sure you want to delete the chosen price category",
  VIEW_PRODUCT: "Viewing product",
  CREATE_PRODUCT: "Creating a product",
  PRODUCT_CATEGORY: "Product category",
  PRODUCT_NAME: "Name of the product",
  PRODUCT_PRICE: "Price of the product",
  PRODUCT_DESCRIPTION: "Description of the product",
  PRODUCT_VAT: "VAT % of the product",
  PRODUCT_BRAND: "Brand name of the product",
  PRODUCT_PICTURE: "Picture of the product",
  PRODUCT_CATEGORIES: "Categories of the product",
  PRODUCT_CAPACITY: "Product capacity",
  PRODUCT_AGE: "Minimum age for product",
  PRODUCT_TYPE: "Type of the product",

  // Rental
  RENTAL_PERIOD: "Choose a date",
  CHECK_AVAILABILITY: "Save period info",

  //Linda input
  LINDA_SUGGESTIONS_DIALOG: "Linda is getting the suggestions",
  LINDA_FOOD_AND_BEVERAGE:
    "Here you can add food and beverage before or after your event",
  LINDA_ADD_FOOD_BEFORE: "Add food and beverage before your event",
  LINDA_ADD_FOOD_AFTER: "Add food and beverage after your event",
  LINDA_SEARCHING: "Linda is searching for your selected event",
  LINDA_LOGIN_WELCOME: "Welcome, my name is Linda.",
  LINDA_LOGIN_HELPING_HAND:
    "I will help you plan a day away, to ensure you, you will get the maximum out ot your day away and bypass the crowds.",
  LINDA_LOGIN_SHORT_INFO:
    "With Linda you can make a appointment within 5 minutes. With this appointment Linda ensures that your day is careless and without traffic jams or queues.",
  LINDA_WELCOME: "Welcome!",
  LINDA_REGISTER_USERINFO:
    "To start off, i need some information, so i know for who i am planning.",
  LINDA_REGISTER_LATER:
    "This way i can notice you in a later stage for your appointment.",
  LINDA_REGISTER_DONE: "Thank you for registering",
  LINDA_REGISTER_MAIL:
    " Finished! Thanks for creating your accountName passport. We’ve sent you a confirmation email with a link to activate your passport. Please press the link to activate your passport. Check your spam folder in case you didn’t receive the conformation email. ",

  LINDA_BIGGER_GAP_OR_GROUPSIZE:
    "Try to make the time gap bigger and/or the groupsize smaller.",
  LINDA_ACCOUNT_CREATION_FIRST_STEP: "Great! Your account has been made",
  LINDA_ACCOUNT_CREATION_FIRST_STEP_DESC:
    "I have send you an email with a link.\nClick on the link in your email to activate your account",
  LINDA_ACCOUNT_CREATION: "Welcome!",
  LINDA_WELCOME_BACK: "Welcome back!",
  LINDA_ACCOUNT_READY_TO_CREATE:
    "To begin I need to know who you are, so I can create an account for you.",
  LINDA_USER_TRIPLIST:
    "Look at your appointments or create a new one. You can retrieve your tickets by clicking on a appointment.",
  LINDA_WHERE_TO: "Where do you want to go?",
  LINDA_SEARCH_EVENT: "Choose an event to continue",
  LINDA_DATE_PICKER_WELCOME: "Allright, lets choose a date.",
  LINDA_DATE_PICKER: "When are you planning to leave?",
  LINDA_SPECIAL_CODE: "Have you received a VIP code in the mail?",
  LINDA_TRIP_DETAIL:
    "With whom you want to go and at what time do you think you will arrive and leave?",
  LINDA_ACTIVITY_LIST:
    "I want to create a list of the activitites you want to see and do. By doing this, i will make sure you can surely visit all of them.",
  LINDA_ADJUST_INFO: "These info is adjustable in a later stage.",
  LINDA_MODE_OF_TRANSPORT: "How are you planning to travel?",
  LINDA_SAVING_A_SPOT:
    "This way i can help you save a parking spot or check if there is any public transport/shuttle bus available.",
  LINDA_CHECK_INPUT:
    "Please check all the data, so we can ensure nothing goes wrong.",
  LINDA_MEETING_SET: "The booking process has been completed",
  LINDA_MEETING_SET2:
    "Your booking request has been forwarded to our partner for confirmation.",
  LINDA_ERROR: "Something went wrong.",
  LINDA_ERROR_PAYMENT: "Your payment has not been received. Check your account",
  LINDA_ADJUST_TIME:
    "You can change the time and mode of transport if it is not correctly anymore.",
  REGISTER_LINDA: "Register",
  LINDA_EVENT_NAME: "Choose a event",
  LINDA_VIP: "Discount code",
  LINDA_VIP_DIALOG:
    "If you have recieved a discount code in your mail, please enter it below or press next.",
  LINDA_USERGROUP_DIALOG:
    "If you have recieved a special code, please enter it below",
  LINDA_VIP_INPUT: "Please enter your discount code here",
  LINDA_GROUP_SIZE: "Group size",
  LINDA_GS_INPUT: "Set groupsize",
  LINDA_ARRIVAL: "Expected arrival",
  LINDA_ARRIVAL_LABEL: "Arrival time",
  LINDA_DEPARTURE_LABEL: "Departure time",
  LINDA_DEPARTURE: "Expected departure",
  LINDA_TRANSPORT_TYPE: "Transport type",
  LINDA_ATTEND: "What do you want to attend?",
  LINDA_NO_SUBEVENTS: "There are no sub-events available",
  LINDA_FILL_REQUIRED: "Please fill in all the required fields",
  LINDA_NEW_APPOINTMENT: "New appointment",
  LINDA_APPOINTMENTS: "Your appointments",
  LINDA_NO_APPOINTMENTS: "No appointments",
  LINDA_GO_TO_APPOINTMENTS: "Go to my activities",
  LINDA_ORDER: "Your order",
  LINDA_STARTTIME: "Start time",
  LINDA_ENDTIME: "End time",
  LINDA_DELETE_APPOINTMENT: "Are you sure you want to delete the appointment?",
  LINDA_CALENDAR_CROWDED: "Crowded ",
  LINDA_CALENDAR_CALM: "Calm ",
  LINDA_CALENDAR_AVERAGE: "Average ",
  LINDA_CALENDAR_SELECTED: "Selected ",
  LINDA_TRANSPORT_MODE: "Mode of transport",
  LINDA_NO_TRANSPORT_AVAILABLE: "There is no mode of transport available",
  LINDA_MANDATORY_TRANSPORT: "Please select a mode of transport to continue",
  LINDA_TOTAL_PRICE: "Total Price",
  LINDA_CANCEL_ORDER: "Cancel",
  LINDA_CONFIRM_ORDER: "Confirm",
  LINDA_ORDER_FAILED:
    "The appointment has been deleted, please check your mail for further instructions.",
  CLOSE: "Close",
  LINDA_REGISTER_TO: "Register to...",
  LINDA_MISS_NOTHING: "Miss nothing",
  LINDA_OWN_PROGRAM: "Create your own program",
  LINDA_AVOID: "Avoid queues",
  LINDA_PLAN_VISIT: "Plan your visit with Linda",
  LINDA_ENJOY: "Enjoy to the fullest",
  LINDA_ADVANTAGE: "Take advantage of extra's and discounts",
  LINDA_ACCOUNT_MADE_TITLE:
    "Great! The account is made. To activate the account I need the style of your company.",
  LINDA_ACCOUNT_MADE_BODY:
    "I will make sure your account will look like it's yours",
  LINDA_NONE: "None",
  LINDA_PLANNED_SUCCESSFULL: "A confirmation email has been sent",
  LINDA_PLANNED_SUCCESSFULL2:
    "You will receive a message when the partner has confirmed or rejected your booking request.",
  LINDA_KEEPS_PROMISE: "The appointment can be found in my activities",
  LINDA_TICKETS_TO_MAIL:
    "i've send the tickets in the mail to your mail account!",
  LINDA_TICKET_INFO_ACCOUNT:
    "You can also retrieve the tickets by clicking on the information of your appointment.",
  LINDA_BG_MEANING:
    "To spread the users over your facilities, you need to create batchgroups. These batchgroups exist from different batches.",
  LINDA_BG_FILLING:
    "With this, i can plan the users in for different batches and make sure all batches are well filled.",
  LINDA_THEME: "Theme",
  LINDA_GETTING_EVENTS: "Linda is getting the events",
  LINDA_CHECK_YOUR_ORDER: "Check your choices",
  LINDA_PLEASE_FILL_IN: "Please fill the fields in",

  //Web stepper two

  STEP_THEME: "Selecting the theme",
  STEP_DETAILS: "Trip details",
  STEP_WISHLIST: "Wishlist",
  STEP_PLAN: "Plan your day",
  STEP_TRANSPORT: "Transport mode",
  STEP_ISSUES: "Issues",
  STEP_CONFIRM: "Confirmation",

  PREVIOUS: "Previous",
  CONTINUE: "Continue",
  NEXT: "Next",
  CANCEL: "Cancel",
  CANCEL_TOOLTIP: "Cancel",
  LOGIN: "Login",
  USERNAME: "Username",
  PASSWORD: "Password",
  LOGIN_TEXT: "Already got an account?",
  REGISTER_TEXT: "Create an account",
  ACTIVATION_CODE_REQUIRED: "activation code is required",
  ACTIVATION_CODE_TITLE: "Activation code: ",
  ACTIVATION_CODE_TEXT:
    "Please enter the activation code you received by email after creating your account. ",
  ACTIVATION_CODE_INPUT: "Enter your activation code",
  ALERT:
    "The app is not yet available. You will receive an email as soon as the app is available for downloading.",

  SAVE_RELATION: "Save relation",
  MAKE_ROUTE: "Make route",

  TITLE: "Title",
  TEXT: "Text",
  DESTINATION: "Destination",
  ACCOUNT_PREFERENCES_SAVED_CORRECTLY:
    "Account preferences are saved correctly!",
  PARTNER_PREFERENCES_SAVED_CORRECTLY:
    "Partner preferences are saved correctly!",
  ACCOUNT_ALREADY_ACTIVATED: "Your account is already Activated!",
  LOCATION_CREATION_OK: "Location created successfully",
  LOCATION_EDITING_OK: "Location edited successfully",
  USERGROUP_INFO_SAVED_OK: "UserGroup info saved successfully",
  ACCOUNT_SAVED_OK: "Account saved successfully",
  USERGROUP: "User group",
  DELETE_USERGROUP_TITLE: "Are you sure to delete the Usergroup?",
  ACCOUNT_MNG: "Account Management",
  CREATE: "Create",
  SEND: "Send",
  SAVE: "Save",
  DELETE: "Delete",
  SAVE_TOOLTIP: "Save changes",
  SEND_VIP_CODE: "Send VIP code",
  SEND_USERGROUP_CODE: "Send code",

  ONCE_ONLY_NOTIFICATION: "Only-once notification",
  CREATE_NEW_NOTIFICATION: "Create new notification",
  LOCATION_NOTIFICATION: "Location notifications",
  ALL_NOTIFICATION: "All notifications",
  EDIT_NOTIFICATION: "Edit notification",

  CONFIRM_REGISTER: "Registration confirmed",

  NO_ACCOUNT_ID:
    "There is no account id specified in the URL or the account does not exist for this account",
  NO_PARTNER_ID:
    "The partner id is invalid or not specified in the URL. Please enter a valid partner id.",
  ACCOUNT_NAME: "Account name",
  ACCOUNT_DESCRIPTION: "Account description",
  LOCATION_OVERVIEW: "Locations Overview",
  EVENT_OVERVIEW: "Events Overview",
  STATISTICS: "Statistics",
  LOCATIONS: "Locations",
  CREATE_TOUR: "Create tour",
  CONFIGURE_ROUTE: "Configure route",
  SHOW_ROUTE: "Manual",
  SHOW_WAYPOINTS: "Automatic",
  ACCOUNT_TITLE: "Account",
  DASHBOARD_TITLE: "Dashboard",
  ACCOUNT_URL: "Website URL",
  ACCOUNT_EMAIL: "Email address administrator",
  ACCOUNT_TITLE_AUTOCOMPLETE: "Name organisation",
  ACCOUNT_TITLE_CREATE_STYLE: "Create your own style",
  ACCOUNT_URL_AUTOCOMPLETE: "Website URL",
  ACCOUNT_EMAIL_AUTOCOMPLETE: "Email address administrator",
  ACCOUNT_CONFIRMATION: "Account confirmation",
  ACCOUNT_SELECTION_CONFIRMATION:
    "Are you sure you want to confirm your account with these data?",
  ACCOUNT_CHANGES_LATER: "You can still change it later",
  ACCOUNT_LINK: "Link",
  ACCOUNT_MAIN_LOCATION: "Main location",
  ACCOUNT_ADMIN_NUMBER_SALE: "Administration number sale",
  ACCOUNT_ADMIN_NUMBER_FEE: "Administration number fee",
  ACCOUNT_SERVICE_PERCENTAGE: "Service percentage",
  ACCOUNT_MAX_PREBOOKS: "Max Prebooks",
  ACCOUNT_HIGH_VAT: "High VAT",
  ACCOUNT_LOW_VAT: "Low VAT",
  "ACCOUNT_SALES_&_FEES": "Sales & Fees settings for",
  ACCOUNT_BOOKNUMBER_FEE: "Booknumber Fees",
  ACCOUNT_JOURNAL_NUMBER_SALES: "Journal number Sales",
  ACCOUNT_JOURNAL_NUMBER_FEES: "Journal number Fees",
  ACCOUNT_NAME_OF_FILE: "Name of file",
  ACCOUNT_MONTHLY_FEE_GENERATION_DAY: "Monthly fee generation day",
  ACCOUNT_GENERATION_DAY: "Generation day",
  ACCOUNT_SAVE_SALES_FEE:
    "Please save the sales & fees settings first, before you click on each of the buttons below.",
  ACCOUNT_BOTH_BUTTONS: "Both buttons will be called on account",
  ACCOUNT_GENERATE_SALES_FEES: "Generate Sales Fees",
  ACCOUNT_GENERATE_MONTHLY_FEES: "Generate Monthly Fees",
  ACCOUNT_USERGROUP_NAME: "Usergroup name",
  ACCOUNT_NEW_USERGROUP: "New usergroup",
  ACCOUNT_EDIT_USERGROUP: "Edit usergroup",

  ACCOUNT_USER_ROLE_DESCRIPTION: "User Role",
  ACCOUNT_USER_ROLE_PARTNER: "Partner",
  ACCOUNT_NEW_USER_ROLE: "New User Role",
  ACCOUNT_EDIT_USER_ROLE: "Edit User Role",
  ACCOUNT_USER_ROLE_GLOBAL: "Global",
  DELETE_USER_ROLE_TITLE: "Are you sure to delete the User Role?",
  UR_FOR_USER: "Available user roles",

  ACCOUNT_USER_STATE: "User status",
  ACCOUNT_USER_ID: "User ID",
  ACCOUNT_DELETE_USER: "Are you sure you want to delete the user",
  ACCOUNT_VAT_NUMBER: "VAT number",
  ACCOUNT_VAT_BTW: "Partner VAT number (BTW)",
  ACCOUNT_CAMPAIGN_BUDGET: "Campaign Budget",
  ACCOUNT_PARTNER_SUPPLIER_CODE: "Partner Supplier Code",
  ACCOUNT_SUPPLIER_CODE: "Supplier code",
  // Tool Bar
  FINANCIAL_MANAGEMENT: "Financial Management",
  FINANCIAL: "Financial",
  THEME_LIST: "Homepage",
  THEMES: "Highlights",

  //home
  REGISTER: "Register",
  REGISTER_HEAD: "Don't miss a thing",
  WHY_REGISTER: "Why register for " + appConfig.dss.environmentName + "-app?",
  REGISTER_LIST:
    "Enjoy the " +
    appConfig.dss.environmentName +
    " to the fullest with these benefits for app users only.",
  //'REGISTER_LIST':'Met de app geniet je maximaal van de '+appConfig.dss.environmentName+'! Meld je aan, download de app en mis niets van dit stijlvolle evenement. ',
  REGISTER_LIST_1: "We’ll keep you informed about your favorite events.",
  REGISTER_LIST_2: "Win great prizes.",
  REGISTER_LIST_3: "Purchase your parking ticket online.",
  REGISTER_LIST_4: "Receive special offers and discounts.",
  REGISTER_LIST_5: "Easily find your way with the handy map.  ",
  REGISTER_LIST_6:
    "Register for an account and download the " +
    appConfig.dss.environmentName +
    " in the Apple App Store or Google Play.",
  REGISTER_NOW: "Register now",
  //register
  REGISTER_DETAILS: "Create an account",
  REGISTER_DETAILS_INFO:
    "Please provide us with a few personal details so we can create an account for you",
  REGISTER_INFO: "Why do we ask for this information?",
  REGISTER_PHONE: "Mobile phone number: ",
  REGISTER_PHONE_TEXT:
    "we will keep you informed with text messages if there is a problem with the app.",
  REGISTER_VIP: "Special Code",
  REGISTER_VIP_TEXT:
    "Did you receive a code from the " +
    appConfig.dss.environmentName +
    " organization? Please enter it here. Otherwise please leave the field empty. ",
  REGISTER_ZIPCODE: "Postal code: ",
  REGISTER_ZIPCODE_TEXT:
    "used to gain insight where our visitors come from, so we can attract more sponsors and keep the event free of charge for visitors. ",
  REGISTER_LICENSE: "License Plate: ",
  REGISTER_LICENSE_TEXT:
    "if you travel by car, enter your license plate for fast access to the parking lot. ",
  REGISTER_CHECKBOX: "I agree with the",
  REGISTER_PRIVACY_STATEMENT: "Privacy statement",
  REGISTER_KEEP_ME_UP_TO_DATE:
    "Yes, please keep me informed about the " +
    appConfig.dss.environmentName +
    "",
  REGISTER_FORM_NAME: "Name",
  REGISTER_FORM_LASTNAME: "Surname",
  REGISTER_FORM_EMAIL: "E-mail",
  REGISTER_FORM_PHONE: "Mobile phone number",
  REGISTER_FORM_ZIP: "Postal code",
  REGISTER_FORM_COUNTRY: "Choose a country",
  REGISTER_FORM_VIP: "Special Code",
  REGISTER_FORM_LICENSE: "License plate",
  REGISTER_ACCOUNT: "Register an account",
  REGISTER_INTEREST_TITLE: "Interests",
  REGISTER_INTEREST:
    "Let uw know what you’re interested in, so we can provide you with upcoming events that match your interests",
  REGISTER_ACCOMPANY:
    "Let us know who will accompany you, so we can help you pick suitable events.",
  REGISTER_ACCOMPANY_TITLE: "I will visit with",

  GRAPH_0_LABEL_0: "Arrived",
  GRAPH_0_LABEL_1: "Expected",
  GRAPH_0: "Bezoekers",
  GRAPH_0_OPT: "Bezoekers",
  GRAPH_N_ARRIVALS: "Number of arrivals",
  GRAPH_N_ARRIVALS_OPT: "Optimized number of arrivals",
  GRAPH_N_DEPARTURE_OPT: "Optimized number of departure",
  GRAPH_N_DEPARTURE: "Number of departure",

  GRAPH_0: "Total",
  GRAPH_1: "Fixed",
  GRAPH_2: "Flex",
  GRAPH_3: "Slack",
  GRAPH_4: "Queue length",
  GRAPH_5: "Current",

  ERROR_EVENT2_01: "arrivals exceed the capacity of this event",
  ERROR_EVENT2_02: "queue length or waiting time exceeds the threshold",

  ERROR_DESTINATION_01: "Database connection error",
  ERROR_DESTINATION_02: "PushNotificationBridge connection error",
  ERROR_DESTINATION_03: "Reschedule event in the past (not possible)",
  ERROR_DESTINATION_04:
    "Inconsistent event data (time window where endTime <= startTime)",
  ERROR_DESTINATION_05:
    "Max capacity exceeded (when trying to reschedule an event)",
  ERROR_DESTINATION_06:
    "No reward configured (when finalizing an event or triggering a negotiation round)",
  ERROR_DESTINATION_07: "End time - startime bigger than the interval duration",
  ERROR_DESTINATION_08: "Parent object is not of type destination",
  ERROR_DESTINATION_09: "Parent object null",
  ERROR_DESTINATION_10: "Current objecy null",
  ERROR_DESTINATION_11: "Event set back in the past",
  ERROR_DIT_01:
    "No reward configured (when finalizing an event or triggering a negotiation round)",
  ERROR_DIS_01:
    "No reward configured (when finalizing an event or triggering a negotiation round)",
  ERROR_DIT_02: "Dit thread is already running",
  ERROR_EVENT_01: "Passed event id passed not correct",
  ERROR_EVENT_02: "Passed slot id not correct",

  REGISTER_VISIT_WITH:
    "I will visit " + appConfig.dss.environmentName + " with",
  REGISTER_MYSELF: "Myself",
  REGISTER_PARTNER: "My Partner",
  REGISTER_FRIENDS: "Friends",
  REGISTER_KIDS: "Kids",
  REGISTER_SCHOOL: "School",

  SUCCES_REGISTER: "Yippee! Your account has been created",
  // 'SUCCES_REGISTER_TEXT_1': 'Congratulations! Please continue to the next step and let us know which days you will be visiting the event. You can also purchase a parking ticket for Saturday June 30th online if needed.  ',
  SUCCES_REGISTER_TEXT_1:
    "An email has been sent to you with a link to activate your account",
  SUCCES_REGISTER_TEXT_2:
    "Here’s your unique user-id. Use it to activate the app after downloading it in the Apple App Store or Google Play. You’ll also receive your user-id in your email with instructions on how to activate the app.   ",
  SUCCES_REGISTER_USER_ID: "Your user-id: ",
  DOWNLOAD: "Download the app",
  APPLE: "for Apple",
  ANDROID: "for Android",

  APPLY: "Apply",

  TAGS: "Tags",
  TAGS_EVENT: "Select your favorite tags",
  TAGS_TEXT:
    "Please select the tags you like, so we can show you events related to this tags.",
  TAGS_REQ: "Please select the tags",

  //Tickets
  TICKET_NEW: "New ticket type",
  TICKETS_PRICING_EXPLANATION:
    "Because the pricing is externally managed, there is no possibility to add ticket",
  TICKET_SOME_EXPLANATION: "Some explanation about ticket types",
  TICKET: "Tickets",
  TICKET_EVENT: "Select your favorite events",
  TICKET_TEXT:
    "Please select the days you will be visiting us, so we can keep you informed about your favorite events. You can also immediately purchase tickets for paid events. ",
  TICKET_WARNING: "Please note",
  TICKET_TEXT_1:
    " that parking is paid on Saturday June 30th. Purchase your ticket online by selecting “Parking” on the right. An online ticket will allow you to skip the line and avoid the hassle of paying in cash.",
  TICKET_TEXT_2:
    "that purchased tickets are non refundable and non transferable. You will receive your tickets by email within 30 minutes after completing the payment process.",
  TICKET_TEXT_3: "By purchasing your tickets online you agree to our ",
  TICKET_TEXT_TERMS: "general terms.",
  TICKET_ATTEND: "Which days do you want to attend?",
  TICKET_ARRIVING: "What time will you be arriving?",
  TICKET_INFORMATION: "Tickets are handled by the event organization.",
  TICKET_INFORMATION2: "An entrance fee may be charged at the location.",

  //Linda output
  TRIPS: "Trips",
  TRIP_WELCOME: "Welcome to your triplist",
  TRIP_CHOICE:
    'Please select a trip in your specialised triplist to show it or delete it. If there is no trip in your triplist, you can create a trip for this event by clicking on the "+" icon in the top right corner.',
  TRIP_STARTED: "Lets personalise your trip ",
  TRIP_EVENT_PICKER:
    "Please make a choice out of the following events to visit. if you want to add another day on the same event or a new trip, it is possible after the completion of this event registration!",
  TRIP_DATEPICKER:
    "Now that you know what event you will be visiting, lets choose the right date to visit the event. Please click on the date you want to visit the event.",
  TRIP_PLAN: "Plan my trip",

  PAYMENT: "Please confirm your choices ",
  PAYMENT_TEXT:
    "Please check the following data and confirm your choices to complete your ticket registration.",
  PAYMENT_CONFIRM: "Confirm",
  PAYMENT_CONFIRM_PAY: "Confirm and pay",
  PAYMENT_OVERVIEW: "Overview of events:",
  ARRIVAL_INFO: "Selected event days: ",
  ARRIVAL_TIME: "Expected arrival time: ",
  TOTAL_PRICE: "Total price:",

  TICKET_SUCCES: "Hurray! We’re looking forward to welcoming you.",
  // 'TICKET_SUCCES_1': 'Your registration is successful. We’ll send you a confirmation by email.',
  TICKET_SUCCES_1:
    "Your registration is successful. Good luck and enjoy The " +
    appConfig.dss.environmentName +
    " !",
  TICKET_SUCCES_2:
    "Now it’s time to download and activate the app to have a chance at those nice prizes. Good luck and enjoy The " +
    appConfig.dss.environmentName +
    " !",

  TICKET_ORDER: "Order tickets",
  TICKET_ORDER_1: "Confirm your order",
  TICKET_ORDER_2: "",
  EVENT_PAYMENT: "Payment process",
  EVENT_PAYMENT_INFO:
    "You will be redirected to Mollie payments to complete your payment process",
  EVENT_PAYMENT_INFO_1: "",
  TRIP_TICKETS: "Download tickets",

  PAYMENT_SUCCESS: "Payment succeeded",
  PAYMENT_FAILED: "Payment failed",
  TO_APP_USERS:
    "If you are an app user, please return back to the app to continue!",

  TICKET_UNSUCCESSFUL:
    "Oops! We’re very sorry but your payment was unsuccessful",
  TICKET_UNSUCCESSFUL_TEXT:
    "Please try again, we’re sure it’s just a glitch. If you keep encountering this issue, please contact The Driving Force customer service center at customerservice@thedrivingforce.nl or call +31 297 51 44 55. ",
  RETRY: "Retry",

  SUCCES_PAYMENT: "Hurray! Your payment was successful.",
  SUCCES_PAYMENT_1:
    "Your registration is now completed. We’ll send you a confirmation by email with your tickets. We’re looking forward to welcoming you.",
  SUCCES_PAYMENT_2:
    "Now it’s time to download and activate the app to have a chance at those nice prizes. Good luck and enjoy The " +
    appConfig.dss.environmentName +
    ". ",
  Website_Down_1:
    "We are very Sorry but the Webite is temporarily unavailable.",
  Website_Down_2: "We are Working on it and it will be back very soon.",

  DRIP_OBJECT_NAME: "Name DRIP",
  DRIP_OBJECT_DESCRIPTION: "Description of DRIP",
  DRIP_LOCATION: "Right click op de kaart voor de locatie van de DRIP",
  DRIP_IPADDRESS: "IP adres of DRIP",
  DRIP_PORT: "Port number of DRIP",
  DRIP_WINDOWNAME: "Window name of DRIP",
  DRIP_HEIGHT: "Height of DRIP",
  DRIP_BREADTH: "Width of DRIP",

  PRIS_OBJECT_NAME: "Name of PRIS",
  PRIS_OBJECT_DESCRIPTION: "Description of PRIS",
  PRIS_LOCATION: "Right click op de kaart voor de locatie van de PRIS",
  PRIS_IPADDRESS: "IP adres of PRIS",
  PRIS_PORT: "Port number of PRIS",
  PRIS_WINDOWNAME: "Window name of PRIS",
  PRIS_HEIGHT: "Height of PRIS",
  PRIS_BREADTH: "Width of PRIS",

  VRI_OBJECT_NAME: "Name of PRIS",
  VRI_OBJECT_DESCRIPTION: "Description of PRIS",
  VRI_WEBSITE: "Website",
  VRI_IP: "IP adres",
  VRI_IVERA: "Ivera",
  VRI_IVERA_NAME: "Ivera name",
  VRI_PASSWORD: "Ivera password",
  VRI_ITS: "ITS Name",
  VRI_ITS_PASSWORD: "ITS password",
  VRI_TRIGGER_CERT: "Trigger certificate",
  VRI_CERT: "VRI certificate",
  VRI_TRIGGER_IP: "Trigger ip",
  VRI_VTYPE: "V type",
  VRI_VVERSION: "V Version",
  VRI_VNAME: "V name",
  VRI_VPASSWORD: "V password",
  VRI_VSOURCE: "V Source",
  VRI_VIP: "VIP",
  VRI_VPORT: "V Port",
  VRI_CAPACITY: "Capacity",
  VRI_NOTES: "Notes",
  VRI_CONFIG: "Configuere",
  VRI_XY: "XY",
  VRI_KPP: "KPP",
  VRI_ATTACHMENT: "Attchements",

  NO_RELATION: "No relations",
  NO_TRAFFIC_OBJECTS: "No trafficobjects",
  NO_SENSOR_ACTUATOR: "No Sensor actuators",
  NO_EVENTS: "No events",
  NO_EVENTS_AVAILABLE: "No events available",
  AVAILABLE: "Available",
  ADD_RELATION: "Add relation",
  ADD_INCIDENT: "Add indcident",
  ADD_TRAFFIC_OBJECT: "Add trafficobject",
  ADD_SENSOR_ACTUATOR: "Add sensor actuator",
  ADD_EVENTS: "Add event",
  NO_ENTRY_EXIT_POINTS: "No entry/exit points",
  ENTRY_EXIT_POINTS: "Entry and exit points",
  INCIDENTS: "Incidents",
  RELATIONS: "Relations",
  TRAFFIC_OBJECTS: "Trafficobject",
  SENSOR_ACTUATOR: "Sensor / actuators",
  EVENTS: "Events",
  SAVE_RELATION: "Save relation",
  MAKE_ROUTE: "Make route",

  OP_SCREEN: "Operational screens",
  MAP_TITLE: "Map",
  ROUTE_MAP_TITLE: "Route Map",
  ROUTE_MAP_DESC:
    "Click on the map to enter the route editor. Within the route editor you can adjust the route, add stops to your route and more.",
  ROUTE_MAP_DESC_WARNING:
    "If there is no route available, please click on the 'Generate route' button to create the route.",
  TRAVEL_MODE: "Travel mode",
  EVENT_START_PLANNING: "Plan",
  ORDERS: "Orders",
  EVENT_START_SIMULATE: "Simulate",
  FILTER_OPTIONS: "Filter options",

  INVALID_ENDDATE: "The end date is before the start date.",
  INVALID_ENDTIME: "The departure time is before the arrival time.",
  INVALID_INPUT: "The input fields are incorrect filled in.",
  INVALID_WEBSITE: "Invalid website",
  INVALID_EMAIL: "Invalid email address",
  FIELD_REQUIRED: "Field is required",
  FIELD_MAX_LENGTH_32: "Field length cannot exceed 32 chars long!",
  FIELD_MAX_LENGTH_1024: "Field length cannot exceed 1024 chars long!",
  FIELD_MAX_LENGTH_64: "Field length cannot exceed 64 chars long!",
  FIELD_MAX_LENGTH_45: "Field length cannot exceed 45 chars long!",
  FIELD_MAX_LENGTH_128: "Field length cannot exceed 128 chars long!",
  FIELD_NO_SPECIAL_CHARS: "Special chars not admitted ,/\"'{}[]()#$%^&* |",

  DELETE_EVENT_NOK: "You are not the owner of Event, you can not delete it!",
  DELETE_EVENT: "Are you sure want to delete the event?",

  DELETE_USER: "Delete user",
  TAGS_CATEGORIES: "Categories",
  DELETE_FILTERS: "Delete filters",

  // New > still to sort out
  DIRECT_BOOKING: "Direct Bookings",
  ASPECTS: "Aspects",
  NEW_ASPECT: "New aspect",
  BRAND: "Brand",
  COPY: "copy",
  REQUIRED: "Required",
  SORT: "Sort",
  ACTIVE: "Active",
  INACTIVE: "Inactive",
  EDIT_TRANSLATIONS: "Edit translations",
  EDIT_BATCHGROUPS: "Edit batchgroups",
  maintenance:
    "Dear visitor, \n the website is currently under construction. We are working very hard to make the website even better! Please try again later. Sorry for the inconvenience.",
  CREATE_USER: "Create account",
  START_TYPING: "Start typing to Search",
  SQUARE_PER_PERSON: "Square meter per person (in M2)",
  ACTIVITY: "Activity",
  ADD_TO_CARD: "Added to shopping cart",
  VIEW_ORDER: "View order",
  UPDATE_YOUR_ACCOUNT: " Do you want us to update your account?",
  UPDATE_USER: "Update user",
  HOUSE_NUMBER: "House number",
  SELECT_TIME: "Select a time",
  INPUT_FIELDS_EMPTY: "The input fields are empty.",
  NOTHING_FILLED_IN: "Nothing filled in",
  RETURN_TO_MY_ACTIVITIES:
    "The order is saved. you will be returned to the 'My activities' page.",
  REDIRECT_TO_APPOINTMENTS:
    "You will be automatically redirected to your appointments",
  REDIRECT_TO_PAYMENT:
    "You will be automatically redirected to the payment page",
  ORDER_RECEIVED: "Your order has been received.",
  ORDER_INFO: "Order info ",
  ORDER_OVERVIEW: "Order overview",
  ACTIVITY_PRICE: "Activity Price:",
  ORDER_ID: "Your order id:",
  YOUR_ORDER: "Your order",
  FILL_PERSONAL_DETAILS: "Fill your personal details in",
  CHOOSE_PRODUCTS: "Choose your products",
  CHOOSE_DATE: "Choose a date",
  MORE_INFO: "More info",
  ARRIVAL: "Arrival",
  ADD_ACCOMMODATION: " Add accommodation",
  DAILY_ACTIVITIES: "Your daily activities",
  DEPARTURE: "Departure",
  GENERAL: "General",
  ADDRESS: "Address",
  POSTAL_CODE: "Postal code",
  COMPANY_NAME: "Company name",
  COMPANY_EMAIL: "Company email",
  PREFERENCES: "Preferences",
  CUSTOMERS: "Customers",
  SEARCH: "Search",
  ADD: "Add",
  CREATE_USERGROUP: "Create new user group",
  EDIT_USERGROUP: "Edit usergroup",
  DELETE_USERGROUP: "Delete usergroup",
  GROUP: "Group",
  USERGROUPS: "Usergroups",
  USER_ROLES: "User Roles",
  USERGROUP_NAME: "Usergroup name",
  SEARCH_FAILED_FIRST_PART: "Your search for ",
  SEARCH_FAILED_SECOND_PART: " found no results.",
  BATCHGROUPS: "Batchgroups",
  OPTIONS: "Options",
  VIEW_BATCHGROUP: "Viewing batchgroup",
  CREATE_BATCHGROUP: "Creating a batchgroup",
  DAY_MON: "Mon",
  DAY_TUE: "Tue",
  DAY_WED: "Wed",
  DAY_THU: "Thu",
  DAY_FRI: "Fri",
  DAY_SAT: "Sat",
  DAY_SUN: "Sun",
  SELECTED_DATES: "Selected date(s)",
  START_END_DATE_EQUAL_ERROR:
    "The end date is equal to the start date, please change the end date to continue.",
  DETAILS: "Details",
  OWNED_BY: "Owned by",
  VISIBLE_FOR: "Visible for",
  MAIN_EVENT: "Main event",
  EVENT_DELETION: "Event deletion",
  ADD_LANGUAGE_PLUS: "+ Add New Language",
  ADD_LANGUAGE: "Add New Language",
  LANGUAGE: "Language",
  DESCRIPTION: "Description",
  ARRIVAL_TEXT_MSG: "Arrival text message",
  DEPARTURE_TEXT_MSG: "Departure text message",
  PREV_SCREEN: "Go to previous screen",
  DONE: "Done",
  ADD_CHOICE: "Add choice",
  CLOSE_EDIT_WINDOW: "Close edit window",
  WARNING: "Warning",
  UNSAVED_CHANGES:
    "You still have unsaved changes! Are you sure you want to undo the changes.",
  EVENT_DETAILS: "Event details",
  EVENT_INFO: "Info",
  MESSAGE_DELETION: "Message deletion",
  PLAY_AUDIO: "Play audio",
  DELETE_AUDIO: "Delete audio",
  UPLOAD_EVENT_PIC: "Upload a event picture",
  DELETE_LOGO: "Delete logo",
  RESULT: "Result",
  IMAGE: "Image",
  GO: "Go",
  SEARCH_OSM: "Search in OpenStreetMap",
  STREET: "Street",
  CITY: "City",
  COUNTRY: "Country",
  TELEPHONE: "Telephone",
  OPENING_HOURS: "Opening hours (Mo - Fr 08:00 - 17:30)",
  TRANSPORTATION: "Transportation",
  OK: "Ok",
  MY_APPOINTMENTS: "My activities",
  INPUT_RELATION_NAME: "Input relation name",
  MAKE_ROUTE: "Make route",
  SAVE_RELATION: "Save relation",
  MIN_GROUPSIZE: "The group size must be at least 1",
  NO_VALID_TIME_INPUT: "Time input is not valid, please enter a valid time.",
  EVENT_EDITING: "Edit event",
  DELETING_EVENT: "Delete event",
  NEW_EVENT: "New event",
  EDITING: "Editing ",
  LOCATION: "Location",
  EVENT_CAPACITY: "Maximum capacity in persons",
  LEAD_TIME: "Lead time",
  COOLDOWN_TIME: "Cool down time",
  DURATION: "Duration",
  SELECT_SUBACTIVITIES: "Select subactivities",
  SELECTED_SUBACTIVITIES: "Selected subactivities",
  EVENT_PICTURE: "Event picture",
  CATEGORIES: "Categories",
  AVAILABLE_OTHER_ACCOUNTS: "Available for other accounts",
  VISIBILITY: "Visibility",
  ALL_EVENTS: "All events",
  NO_EVENT_AVAILABLE: "No events available",
  NAME: "Name",
  UPLOAD_IMAGE: "Upload image",
  USER_NOT_LOGGED_IN_TO_RETRIEVE_PAYMENTS:
    "Unfortunately you are not logged in to retrieve payments information. Please log in and retry!",
  GROUP_SIZE: "Group size",
  QUANTITY: "Quantity",
  TOTAL: "Total",
  SUBTOTAL: "Subtotal",
  ADD_TAGS: "Add tags",
  TOTAL_INCIDENTS: "Total incidents",
  ADD_INCIDENT: "Add incident",
  VIEW_DETAILS: "View details",
  SAVE_INCIDENT: "Save incident",
  SAVE_IMAGE: "Save image",
  ADD_LOCATION: "Add location",
  ADD_A_LOCATION: "Add a location",
  EDIT_LOCATION: "Edit location",
  DEL_LOCATION: "Delete location",
  TOURCREATION_GENERATE:
    "Click the button to generate a route with the parameters specified above. It is mandatory to click the button if the route has not been generated for the first time.",
  TOURCREATION_MANUAL_DESC:
    "The manual mode offers a large variety of manual options. All the options listed in manual mode are possible without regenarating the route.",
  TOURCREATION_STOPS_DESC:
    "Only in manual mode the stops can de added to the route.",
  TOURCREATION_PATHPOINTS_DESC:
    "Pathpoints are there to create a manual route, as an example: if the route goes through the water where ne road is available, you must use the Manual mode. The pathpoints are adjustable, it can be changed to a stop or a point. Pathpoints are also removeable. By removing for example point 13, point 14 will become point 13 and attach itself to point 12.",
  TOURCREATION_MANUAL_HOWTO:
    "By clicking on the plus button to add a pathpoint, you will enter the add-mode. In the add-mode you can add pathpoints by clicking on the map. If you want to exit the add-mode, click on the button 'Stop adding pathpoints'",
  TOURCREATION_AUTO_DESC:
    "The automatic mode offers the possibility to add/delete waypoints to the route.",
  TOURCREATION_WAYPOINTS_DESC:
    "Waypoints are there to create a route over roads. If a waypoint is placed outside of the road, the route does not move to that point. Whenever a waypoint is added or deleted, the route will be regenerated. This means that the pathpoints including the stops are deleted. If you do want to change an existing route, please open the tab 'manual'.",
  TOURCREATION_WAYPOINTS_HOWTO:
    "By clicking on the plus button to add a waypoint, you will enter the add-mode. In the add-mode you can add waypoints by clicking on the map. If you want to exit the add-mode, click on the button 'Stop adding waypoints'. Whenever you clicked the button, the route is regenerated.",
  LINK_ACTIVATE_ACCOUNT: "Open the link in the mail to activate your account.",
  WRONG_TIME_INPUT: "Time input is not valid, please enter a valid time.",
  MESSAGE_TITLE_TEXT: "Please enter the message title and text to continue",
  ERROR_MSG_NO_PLACE_SUB_EVENT:
    "There is no place available for a chosen sub event(s): ",
  ERROR_MSG_INVALID_TIME: "Invalid input of time",
  ERROR_MSG_INVALID_DATE: "Invalid input of date",
  ERROR_MSG_NO_ENTRY_TRANSPORT:
    "There are no available entry points left for this type of transport",
  ERROR_MSG_EVENTS_RESET: "Your events have been reset, please reselect them.",
  ERROR_MSG_ARRIVAL_DEPARTURE: "Please change the arrival or departure time.",
  WARNING_MSG_EARLY: "Are you sure you want to arrivate at ",
  MAIN_EVENT_START: "The main event will start at ",
  ERROR_MSG_NO_PLACE_MAIN_EVENT:
    "There is no place available for the main event: ",
  ERROR_MSG_NO_PLACE_TRANSPORT_MODE:
    "There are no available spaces left for the chosen mode of transport",
  ERROR_MSG_NO_MAIN_BATCH_CHOSEN_TIME:
    "No main batch in the time range, please select a different time range",
  SELECT_TRIP_DAY: "Please select the day to view your trip list",
  ENTER_SPECIAL_CODE: "Enter special code",
  WRONG_INPUT: "Wrong input",
  INPUT_NOT_COMPLETE: "Your input is not complete or right",
  VALID_VIP_CODE: "Please enter a valid VIP code",
  MY_EVENTS: "My events",
  PART_OF: "Part of",
  SELECTION_OF_USERS: "Selection of users",
  CRITERIA_BOTH: "Registered & non-registered users",
  CRITERIA_REG: "Registered users",
  CRITERIA_NOT_REG: "Non-registered users ",
  UG_FOR_USER: "Available usergroups",
  SELECTED_UG_FOR_USER: "User is already registered for: ",
  WEB_BROWSER_VERSION: "Chrome browser version",
  UPDATE_BROWSER_DETECTION:
    "The system detected that the version of the chrome browser you are working on is not up-to-date.",
  UPDATE_BROWSER_FAILS:
    "Because of this, some functionalities could not work properly.",
  UPDATE_BROWSER: "Please update your chrome browser to the latest version.",
  CALENDAR: "Whats on",
  ONLY: "Only",
  FREE_PLACES: "places available",
  MINUTES: "minutes",
  BOOK: "Book",
  LOCATION_PICTURE: "Location picture",
  UPLOAD_LOCATION_PIC: "Upload a location picture",
  TOGGLE_MAP: "Toggle map",
  TOGGLE_ACTIVITYLIST: "Show daily activities",

  // Partner
  PARTNER_LEVEL: "Partner level",
  PARTNERS: "Partners",
  PARTNER_DETAILS: "Partner details",
  DELETE_PARTNER_TITLE: "Are you sure to delete the Partner?",
  PARTNER_NAME: "Partner name",
  PARTNER_ADDRESS: "Partner address",
  PARTNER_CITY: "Partner city",
  PARTNER_EMAIL: "Partner email",
  ADMINISTRATION_PARTNER_EMAIL: "Partner administration email",
  PARTNER_POSTAL_CODE: "Partner postal code",
  PARTNER_IBAN: "Partner IBAN",
  PARTNER_TYPE: "Partner type",
  SERVICE_PRICE: "Service price",
  SERVICE_PRICE_PERCENTAGE: "Service price percentage",
  SERVICE_MINIMUM_PRICE: "Minimum service price",
  PLANNING_CONTRACT: "Planning contract",
  PAYMENT_CONTRACT: "Payment contract",
  PAYMENT_PLATFORM: "Payment platform",
  ACCOUNT_HOLDER_NAME: "Account holder name",
  DIRECT_DEBIT_AUTHORISATION_DATE: "Direct debit authorisation date",
  DIRECT_DEBIT_MANDATE_ID: "Direct debit mandate id",
  CREATE_PARTNER: "Create partner",
  TERMS_ACCEPT: "I accept the",
  DIRECT_DEBIT: "I accept direct debit",
  ACTIVE_PARTNER: "Activate partner",
  MIN_MONTHLY_FEE: "Minimum monthly fee",
  SERVICE_ORDER_VALUE_THRESHOLD: "Service order value threshold",

  //Event Delivery fees
  EVENT_DELIVERY_FEE: "Delivery fees",
  EVENT_DELIVERY_FEE_BUTTON:
    "Click on the button below to open up the event delivery fees",
  DELIVERY_FEES_CONFIGURATOR: "Delivery fees configurator",
  STANDARD_DELIVERY_FEE: "Standard delivery fee",
  EXPL_STANDARD_DEL_FEE:
    "This will be the fallback option if the postal code from the user does not match the additional delivery fee postal-codes.\n" +
    "The standard delivery fee is mandatory if you want to add additional delivery fees for specific postal-codes.",
  DELIVERY_FEE_WHOLECOUNTRY:
    "Select this option if the delivery fee is not for specific postal codes, but for the whole country.",
  ADDITIONAL_DELIVERY_FEE: "Additional delivery fee",
  EXPL_ADDITIONAL_DEL_FEE:
    "Extra delivery options specific for a range of postal codes can be added here.",
  NEW_DELIVERY_FEE: "New delivery fee",
  POSTAL_CODES: "Postal codes",
  POSTAL_CODE_RANGE: "New postal code range",
  NEW_DELIVERY_FEE: "New delivery fee",
  EDIT_DELIVERY_FEE: "Edit delivery fee",
  NEW_POSTAL_CODE_RANGE: "New postal code range",
  EDIT_POSTAL_CODE_RANGE: "Edit postal code range",
  ONLY_NUMBERS_ALLOWED: "Only numbers are allowed",
  MIN_ORDER_VALUE: "Minimum order value",
  DELIVERY_ALLOWED: "Delivery allowed",

  // Empty slots
  EMPTY_SLOTS_TITLE: "Are you sure to empty these slots?",

  //Suggestions
  SUGGESTIONS_SELECTED: "Selected suggestions",
  SUGGESTIONS_SELECT: "Select suggestions",
  SUGGESTIONS: "Suggestions",
  SUGGESTIONS_NO_PLACES:
    "The suggestions doesn't have places left. You can choose another suggestion.",
  SUGGESTION_BOOK_FAILED: "Book suggestion not possible",
  NO_SUGGESTIONS_FOUND: "No suggestions found",
  NO_SUGGESTIONS: "There aren't suggestions found",
  NO_CAPACITY: "No capacity",
  LIST_OF_SUGGESTIONS: "List of the suggestions",
  ADD_SUGGESTION: "Add suggestion",
  ADD_SUGGESTION_ACCEPT:
    "Are you sure you want to add this suggestion to your order?",
  CANCEL_YOUR_ORDER: "Cancel order",
  CANCEL_YOUR_ORDER_ACCEPT: "Are you sure you want to cancel your order?",
  REMOVE_SUGGESTION: "Remove suggestion",
  REMOVE_SUGGESTION_ACCEPT: "Are you sure you want to remove this suggestion?",
  NO_IM_NOT: "No I'm not",
  YES_I_AM: "Yes I am",
  SUGGESTION_MAKE_CHOICE: "Make a choice",
  SUGGESTION_DRINKING: "I want something to drink",
  SUGGESTION_EATING: "I want something to eat",

  //Calendar
  CALENDAR_EVENT_STARTTIME: "Start time",
  CALENDAR_EVENT_ENDTIME: "End time",
  CALANDER_NAME: "Calendar",
  CALENDAR_NO_ITEMS: "There are no calendar items for the selected days.",

  //Statistics
  GET_STATISTICS: "Get statistics",
  STATISTICS_OF_TRIPS: "Statistics of Trips",
  STATISTICS_OF_SUGGESTIONS: "Statistics of Suggestions",
  STATISTICS_OF_DIRECT_BOOKING: "Statistics of Direct Bookings",
  STATISTICS_OF_PARTNERS: "Statistics of Partners",
  STATISTICS_OF_USERS: "Statistics of Users",
  STATISTICS_SELECT_THE_DATES: "Select the dates",
  STATISTICS_SELECT_THE_PARTNER: "Select the partner",

  // Activity details screen
  BACK_TO_PARENT: "Back to previous event",
  CHOOSE_A_LOCATION: "Choose a location",
  CHOICES: "Choices",
  READ_MORE: "Read more",
  READ_LESS: "Read less",
  DELIVERY_FEE: "delivery fee",
  MORE_PRODUCTS: "more products",
  OR_ORDER_FOR: "Or order for",
  SELECT_THIS: "If you select this one you have to pay",
  CONFIRM_YOUR_CHOICES: "Confirm your choices",
  CONFIRM_YOUR_CHOICES_EXPLANATION: "Review your choices and press confirm.",
  PERSONAL_DETAILS_EXPLANATION:
    "Enter the necessary personal details and leave a comment for special requests if desired.",
  ENTER_YOUR_PERSONAL_DETAILS: "Enter your personal details",
  CHOOSE_AN_OPTION: "Choose an option",
  CLICK_TO_OPEN: "Click to open",
  STARTING_AT: "Starting at",
  AND: "and",
  SHOWING_OPTION:
    "Indicate the number of persons of the desired option or ticket.",
  SELECTED_DATA_EXPLANATION:
    "Choose a date or period and a start and end time when applicable.",
  PRODUCT_BELOW_EXPLANATION:
    "Below you will find the products. Add the products you want and then press order now.",
  BOOKING_FLOW_EXPLANATION:
    "You are now in the booking process fill in the following fields to continue.",
  EXPLAINING_COLOR_CHIPS:
    "The colors below indicate how busy it is in certain timeslots",
  NO_PRODUCTS: "There are no products in your shopping cart",
  NO_DAYS_AVAILABLE: "No days available",
  NO_BOOKINGS_YET: "Nothing has been booked yet",
  PRE_EVENT_NOTIFICATIONS: "Activate pre-event notifications",
  PRE_EVENT_NOTIFICATIONS_EXPLANATION:
    "When you select this, you receive a message a few minutes before the event starts.",
  NO_ENDTIMES:
    "Can't get end times with the chosen start time, please choose another start time.",
  CANT_FIND_STARTIME: "Can't find a start time with this start date",
  CANT_FIND_ENDDATE: "Can't find an end date with this start time",
  CANT_FIND_ENDTIME: "Can't find an end time with this end date",
  CHOSEN_DETAILS: "Chosen details",
  STARTDATE: "Start date",
  ENDDATE: "End date",
  ACCEPT: "Accept",
  AMOUNT: "Amount",
  AVA_DAYS: "Available days",
  OPEN_HOURS: "Opening hours",
  HOURS: "hour",
  PRICE: "Prices starting at",
  PRICE2: "Price",
  CONTACT: "Contact",
  PHONE_NR: "Phone number",
  PHONE_NR_REQUIRED: "Phone number (required)",
  REQUEST_CLIENT1: "Choose a time",
  REQUEST_CLIENT2: "Please choose an amount of tickets.",
  OPENED_AT: "Opened at",
  CLOSED_AT: "Closed at",
  SAVE_DETAILS:
    "Save the personal details in my account for future reservations or orders",
  NO_PLACE: "No place",
  NO_PLACE_BATCH: "No place in this time slot please choose a different one",
  FREE_DELIVERY: "Free delivery",
  EX_DELIVERY_FEE: "Ex. deliveryfee",
  MONDAY: "Monday",
  TUESDAY: "Tuesday",
  WEDNESDAY: "Wednesday",
  THURSDAY: "Thursday",
  FRIDAY: "Friday",
  SATURDAY: "Saturday",
  SUNDAY: "Sunday",
  PRICE_PERCENTAGE: "Price percentage",
  PRICE_OVERVIEW: "Price overview",
  PERCENTAGE_EXPLANATION:
    "This percentage displays the percentage from the orignal price.",
  UNAVAILABLE: "Unavailable items",
  ITEMS: "Items",
  ADD_ITEMS: "Add items",
  UNAVAILABLE_TEXT:
    "There are unavailable items. Do you accept that you can't buy these items.",
  PLEASE_STARTDATE: "Please choose a start date",
  PLEASE_ENDDATE: "Please choose an end date",
  PLEASE_STARTTIME: "Please choose a start time",
  PLEASE_ENDTIME: "Please choose an end time",
  CROWDED: "Crowded",
  UNCROWDED: "Uncrowded",
  NORMAL: "Normal",
  BOOKED: "Booked",
  OUT_OF_STOCK: "This product is out of stock",
  AVAILABLE_PRICES: "Available prices",
  PRODUCT_INFO: "Product information",
  PRICE_STARTING_AT: "Price starting at",
  NOT_AVAILABLE: "Not available",
  ALMOST_FULL: "Almost full",
  NOT_BUSY: "Not busy",
  SELECT_ORDERTYPE: "Please select the type of order",
  REMARK: "Comments",
  REMARK_OPTIONAL: "Comments (optional)",
  DELIVERY_DISTANCE: "Delivery distance",

  REGISTER_PAGE_TEXT:
    "To create your personal accountName passport, we only need your email address. Your email address will also be used to send you booking confirmations and tickets when you book activities. ",
  REGISTER_PAGE_WELCOME:
    "To create your account, we only need your email address. Your email address will also be used to send you booking confirmations and tickets when you book activities. ",
  LOGIN_PERSONAL:
    "Please login to your personal accountName passport. Don’t have a passport yet? Register to create one in just one minute. With your accountName passport you can easily plan and book your visit to accountName, save your favourite activities and get discounts for your visit to accountName. ",

  //orders
  ORDER: "Select event",
  ORDER_LIST_EMPTY: "List is empty",
  ORDER_NO_ORDERS: "No orders",
  ORDER_NO_ORDERS_FOUND: "There are no orders found",
  ORDER_DOWNLOAD: "Download",
  ORDER_NOW: "Order now",
  ORDER_TYPE: "Order type",
  ORDER_NR: "Order nr",
  ORDER_DETAILS: "Order details",
  NOTHING_DROPPED: "Nothing dropped",
  DROPPED: "Dropped",
  ORDER_STATUS: "Order status",

  // Error codes
  E_00_00: "Something went wrong, please try again later",
  E_PO_010:
    "The different slots for the activity where not available right now, please try again later",
  E_PO_011:
    "It was not possible to add an activity to the planboard, please check your planboard and try a different date or time.",
  E_PO_012:
    "It was not possible to add an activity to the planboard, please try again later",
  E_PO_013:
    "The chosen slot has no capacity, please try a different slot if available",
  E_PO_014:
    "It was not possible to change the chosen activity in your planboard",
  E_PO_015:
    "You are not allowed to edit this activity, because the status for payment is not 'paid'",
  E_PO_016:
    "The chosen time is in a different slots-group, please choose a different time",
  E_BK_001:
    "Unfortunately the chosen location of the event is too crowded, please try to change the arrival or departure time and try again. ",
  E_BK_002:
    "None of the products you've chosen are available, please choose a different time or product and continue.",
  E_PC_003:
    "You can't delete a Price Category that is already linked to a Time slot",
  E_CP_001: "No arrival capacity available",
  E_CP_002: "No departure capacity available",
  E_CP_003: "No event capacity available",
  E_CP_004: "Batch could not be found",
  E_CP_005: "The product has no capacity",
  E_OB_002:
    "The chosen event was not able to retrieve his data, please try again later",
  E_UG_002: "The order does not belong to the current partner",
  E_UG_003: "The order has already been scanned",
  E_UG_004: "The tickets within the order are not confirmed",

  E_ROUTE_001: "No capacity",
  E_ROUTE_002: "There were no orders in the database for the given input",
  E_ROUTE_003: "Route generator has not found a solution within the given time",
  E_ROUTE_004: "There is no solution to the given routing problem",
  E_ROUTE_005: "Route generator not configured correctly",
  E_ROUTE_006: "No route found, please try a different travel mode",
  E_GSD_001: "There are no start dates",
  E_GSD_002: "There are no end dates",
  E_GSD_003: "There are no start times",
  E_GSD_004: "There are no end dates",

  E_MPID_001: "The payment-ID is missing",
  E_RA_001: "Retrieving the event data failed, please try again later",
  E_RA_002: "Retrieving the route aspect data failed, please try again later",
  E_RA_003:
    "The received route aspect data is not for the right event, please try again later",
  E_RA_004:
    "Retrieving the path-points within the route aspect data failed, please try again later",

  E_OM_001: "The order-ID is incorrect.",
  E_OM_002: "The confirmation-ID does not belong to the order-ID.",
  E_OM_003: "The order has already been accepted/rejected.",

  // Back-End Failure
  W_BEF_001: "The received data is incomplete, please try again later. ",
  W_BEF_002:
    "The server is currently offline, SuperLinda and her team are working very hard to solve it. ",

  // GetAccountInfo
  W_GAI_001: "The account data is incomplete, please try again. ",

  // GetUserData
  W_GUD_001: "The user data is incomplete, please try again. ",
  W_GUD_002: "we were not able to receive the user data, please try again. ",

  // GetEventDetails
  W_GED_001: "Loading the picture failed, please try again. ",
  W_GED_002: "Loading the description failed, please try again. ",
  W_GED_003: "Loading the Event-id failed, please try again. ",
  W_GED_004: "Loading the Event details failed, please try again. ",

  // GetCalendar
  W_GC_001: "Loading the calendar failed, please try again. ",

  // GetTourActivities
  W_GTA_001: "Retrieving the tour activities failed,please try again. ",

  // GetThemes
  W_GT_001:
    "Loading the themes for the current account failed, please try again. ",

  // GetChildrenEvents
  W_GCE_001:
    "Loading the events from the selected theme failed, please try again. ",

  // GetFavourites
  W_GF_001: "Loading your favourites failed, please try again. ",

  // Add/Delete Favourite
  W_ADF_001: "Adding/deleting a new favourite failed, please try again. ",

  // GetEventsForLocation
  W_GEFL_001:
    "Retrieving the events for the location failed, please try again. ",

  // GetLocationDetails
  W_GLD_001: "Retrieving the location details failed, please try again. ",

  // GetEventsBasedOnUserLevel
  W_GEBOU_001: "Loading the events failed, please try again. ",

  // GetLocations
  W_GL_001: "Loading the locations failed, please try again. ",

  // DeleteEvent
  W_DE_001: "Something went wrong while deleting the event, please try again. ",

  // GetPostOfEvent
  W_GPOE_001: "Loading the event-poster failed, please try again. ",

  // GetAccounts
  W_GA_001: "Loading the accounts failed, please try again. ",

  // SaveEvent
  W_SE_001: "Saving the event failed, please try again later. ",

  // ActivateAccount
  W_AA_001:
    "No tokens were received after the activation of the account, please try again. ",
  W_AA_002: "Activation of the account failed, please try again. ",

  // CreateAccount
  W_CA_001:
    "Email could not be confirmed because they was no email received, please try again. ",
  W_CA_002: "Creation of the account failed, please try again. ",

  // UpdateAccount
  W_UA_001: "Updating the account failed, please try again later. ",

  // GetExactCsvs
  W_GEC_001: "Loading the Exact-files failed, please try again later. ",

  // GenerateSalesFees
  W_GSF_001: "The generation of sales fees failed, please try again. ",

  // GenerateMonthlyFees
  W_GMF_001: "The generation of the monthly fees failed, please try again.",

  // GetSalesFeesPref
  W_GSFP_001: "There was no start-date received, please try again. ",
  W_GSFP_002: "There was no end-date received, please try again. ",
  W_GSFP_003: "There was no generation date received, please try again. ",
  W_GSFP_004:
    "Loading the Sales and Fees preferences failed, please try again. ",

  // SetSalesFeesPref
  W_SSFP_001:
    "Storing the Sales and Fees preferences failed, please try again. ",

  // Standard Contact Helpdesk
  W_HELPDESK_001:
    "If this problem keeps occurring, please contact the helpdesk from SuperLinda. ",

  //Book
  NOT_CHOSEN: "You haven't chosen anything yet.",

  //shopping cart
  SHOPPINGCART: "Shopping cart",
  SHOPPINGCART_EMPTY: "Your shopping cart is empty",

  //DeliveryRouteGenerate screen
  "TIME/DATEINFO": "Time/Date info",
  DELIVERY: "Delivery",
  TRANSPORT: "Transport",
  GENERATE_ROUTE: "Generate route",
  ADD_DELIVERY_PERSON: "Add delivery person",
  DELIVERY_CONFIG: "Deliver configurator",
  DELIVERER: "Deliverer",
  DELIVERYNR: "Delivery number",
  LOCATION_NOT_FOUND: "Location not found",
  CAR: "Car",
  BICYCLE: "Bicycle",
  WALKING: "Walking",
  HOUR: "Hour",
  START_CONFIGURE: "Start configuring first",

  //Lorenzo added new translations not in Deutsch
  UNCONFIRMED: "Unconfirmed",
  CONFIRMED: "Confirmed",
  WAITING_FOR_PAYMENT: "Waiting for payment",
  ARRIVED: "Arrived",
  FIRSTNAME: "Firstname",
  LASTNAME: "Lastname",
  PLACE_OF_RESIDENCE: "Place of residence",
  DATE_OF_BIRTH: "Date of birth",
  ORDERID: "Order id",

  // Brian added new ones on 08-06-2020, yet to be placed
  USER_SUCCESS_ACTIVATED: "The activation of your account succeeded!",
  USER_SUCCESS_ACTIVATED_LINK:
    "If you registered your account with the app, please return to the app to continue.",
  USER_SUCCESS_ACTIVATED_DOWN:
    "Are you a web user? We also have a app available. If you want to use the app, please click on the store for your phone and download our app or continue on the web.",

  USER_NOT_ACTIVATED_TEXT:
    "Your account has not been activated yet, please click on the activation link in the activation mail that you received to continue.",
  USER_NOT_ACTIVATED_MAIL:
    "If you can't find the mail, or you haven't received the mail yet, please click on the button below to resend the activation mail to: ",
  RESEND_ACTIVATION: "Resend activation-mail",
  ACTIVATION_MAIL_IS_SEND: "The mail has been send to: ",
  USER_FORGOT_PASSWORD:
    "Please click on the button below to resend your login details to your mail",
  RESEND_LOGIN_DETAILS: "Resend login details",
  FORGOT_PASS: "Forgot password?",
  USER_PASS: "Use the following password to login in the app: ",

  EVENT_DESCRIPTION_EC: "Event description",
  EVENT_DURATION_EC: "Average duration",
  EVENT_PART_OF_THEMES_EC: "Part of themes: ",
  EVENT_BUDGET_EC: "Event budget",
  EVENT_REM_BUDGET_EC: "Remaining event budget",
  EVENT_PRE_EVENT_Q_EC: "Pre event question (answer is always yes/no)",
  EVENT_PRE_EVENT_Q_SMALL_EC: "Pre event question",
  EVENT_MANAGED_EC:
    "Please select this option if the event is managed by a planboard",
  EVENT_TICKET_TYPES_EC:
    "To add tickets to the event, please click on the button below",
  EVENT_BOOKING_POL_EC:
    "To add booking policies for the event, please click on the button below",
  EVENT_SUG_EC:
    "To add suggestions to the event, please click on the button below",
  EVENT_ALTER_EC:
    "To add alternatives to the event, please click on the button below",
  EVENT_SUB_ACT_EC:
    "To add sub-activities to the event, please click on the button below",

  //Partner confirmation
  PAR_CON_LEAD_P1: "The confirmation of the order: ",
  PAR_CON_LEAD_P2: " has been received. The new confirmed status is: ",
  PAR_CON_LEAD_P3:
    "There was no confirmation received, please re-click on the link in your mail to try again. ",
  PAR_CON_OR_ST_ACC: "Accepted",
  PAR_CON_OR_ST_REJ: "Rejected",
  PAR_CON_OR_ST_FAI: "Failed",
  PAR_CON_ORDER: "Order-ID: ",
  PAR_CON_CONFIRMATION: "Confirmation-ID: ",
  PAR_CON_STATUS: "Status ",

  // Stock details
  CHANGE_STOCK: "Changing the stock",
  VALID_CAPACITY: "Please enter a valid capacity",
  STOCK_PRO_SUC_CHANGED:
    "The stock for the selected product has successfully been changed",
  STOCK_ITEM_SUC_CHANGED:
    "The stock for the selected product-item has successfully been changed",
  CONFIRM_PRODUCT_PART_1: "Are you sure u want to set the product ",
  CONFIRM_PRODUCT_PART_2: " to 'Out of Stock'? ",
  ENTER_NEW_PRO_STOCK: "Pleas enter the new stock below for the product: ",
  CONFIRM_ITEM:
    "Please confirm that you want to put the selected product-item to 'Out of Stock' ",
  ENTER_NEW_ITEM_STOCK:
    "Please enter the new stock below for the product-item ",

  //location
  LOCATION_SQUARE_PER_PERSON: "Please enter the min. square meter per person",
  LOCATION_PUBLIC_TRANSPORT: "Public transport",
  LOCATION_MARK_LOCATION: "Mark location",
  LOCATION_BOUNDARIES: "Boundaries",
  LOCATION_LATITUDE: "Latitude",
  LOCATION_LONGITUDE: "Longitude",
  LOCATION_RADIUS: "Radius",
  LOCATION_USED_BY: "Used by",
  LOCATION_ENTRY_POINT: "Entry point",
  LOCATION_ENTRY: "Entry",
  LOCATION_EXIT: "Exit",
  "LOCATION_ENTRY/EXIT": "Entry / exit",
  LOCATIONS_CONTAINS: "Location contains",
  LOCATION_ARE_YOU_SURE: "children? Are you sure?",

  //map
  MAP_SELECT_LOCATION: "Select a location with: Right+Click.",
  MAP_TOUR_CONFIGURATION: "Configuration for the tour",
  MAP_SELECTED_TOUR_ACTIVITIES: "Selected tour activities",

  //Policies
  POLICIES_EXPLANATION: "Some explanation about event policies",
  POLICIES_NEW: "New policy",

  //Filter
  FILTER_SELECT: "Select filters",
  FILTER_NO_SELECTED: "No filters selected",
  FILTER_SELECTED: "Selected filters",

  //Alternative
  ALTERNATIVE_SELECT: "Select alternatives",
  // Reviews
  REVIEWS_LOAD_MORE: "Load more",
  REVIEWS: "Reviews",
  REVIEW: "Review",
  REVIEW_WRITE: "Write a review",

  // Calendar Quadrant
  CQ_ORDERDETAILS: "Order details",
  CQ_EXT_EVE_INFO: "External booking, not all details can be shown.",
  CQ_USER_DETAILS: "User details",
  CQ_WEEK_VIEW: "Week view",
  CQ_MONTH_VIEW: "Month view",
  CQ_DATE_STRING_TYPE: "en-us",

  // Account category
  CATEGORY_NAME: "Name of the category",
  CATEGORY_RANKING: "Ranking of the category",
  DELETE_CATEGORY: "Are you sure to delete the selected category",

  // Map icons
  MAP_ICONS: "Map Icons",
  ICON_NAME: "Icon name",
  GREEN_ICON: "Green icon",
  YELLOW_ICON: "Yellow icon",
  RED_ICON: "Red icon",
  EDIT_MAP_ICON: "Edit map icon",
  ADD_MAP_ICON: "Add map icon",
  DELETE_MAP_ICON: "Are you sure to delete the selected map icon",

  // Webshop event
  EVENT_PICKUP_DELIVERY_EC:
    "To add pickup/delivery events, please click on the button below",
  PICKUP_DELIVERY_EVENTS: "Pickup/Delivery Events",
  SELECT_PICKUP_DELIVERY_EVENTS: "Select pickup/delivery events",
  SELECTED_PICKUP_DELIVERY_EVENTS: "Selected pickup/delivery events",

  // Weighted product info
  WEIGHTED_INFO_HEADER: "Weighted product information",
  UNIT_HEADER: "Unit",
  STEP_SIZE_HEADER: "Step size",
  PRICE_PER_STEP_HEADER: "Price per step",
  MINIMUM_QUANTITY_HEADER: "Minimum quantity",
  OVERVIEW_SIZE_HEADER: "Overview size",
  FIXED_PRICE_HEADER: "Fixed price",
  UNIT_INFO: "Unit of the product, like gram",
  STEP_SIZE_INFO: "Step size",
  PRICE_PER_STEP_INFO: "Price per step",
  MINIMUM_QUANTITY_INFO: "Minimum quantity",
  OVERVIEW_SIZE_INFO: "Overview size",
  FIXED_PRICE_INFO: "Fixed price",

  // Product discount
  PRODUCT_ITEMS_WITHOUT_DISCOUNT: "Product items without discounts",
  PRODUCT_ITEMS_WITH_DISCOUNT: "Product items with discounts",
  STOP_DISCOUNT: "Stop Discount",
  START_DISCOUNT: "Start Discount",
  ORIGINAL_PRICE: "Original price",
  DISCOUNT_PRICE: "Discount price",

  PRODUCT_CATEGORY_PICTURE: "Picture",

  // Partner groups
  PARTNER_GROUPS: "Partner groups",
  DELETE_PARTNER_GROUP: "Delete partner group",
  PARTNER_GROUP_NAME: "Partner group name",
  PARTNER_GROUP_PARTNERS: "Partner group partners",
  ADJUST_PARTNERS_FROM_PARTNERGROUP: "Adjust partners from partner group",
  USING_COMMON_APP: "Using common app",
  DUPLICATED_PARTNER_GROUP_NAME_ERROR:
    "Sorry, The name of the partner group already exists. Please change the name and try again.",
  SELECT_PRIMARY_AND_SECONDARY_COLOR:
    "Please select a primary and a secondary color",
  ANDROID_STORE_URL: "Android store url",
  APPLE_STORE_URL: "Apple store url",
  PARTNER_LEVEL: "Partner level",

  // User states
  USER_UNKNOWN: "Unknown",
  USER_STATE_1: "Registered, not activated",
  USER_STATE_2: "Registered and activated",
  USER_STATE_3: "Deleted",
  USER_STATE_4: "Booking made without registration",
  USER_STATE_5: "Imported",
  USER_STATE_6: "Interested",

  DELETE_PARTNER_FEE_CONFIRM_TITLE:
    "Are you sure you want to delete this fee for the partner?",

  PARTNER_DISPLAY_NAME: "Display name"
};
